// cspell:disable
// Use backticks instead of quotes to avoid having to escape apostrophes and quotes in the strings
/* oxlint quotes: ["error", "backtick"] */
export const Strings = {
    ACCOUNT_PROFILE: `アカウントプロフィール`,
    ACCOUNT_CREATED: ``,
    ACCOUNT_VERIFIED: ``,
    LOG_IN_TO_START_ORDERING: ``,
    ADA_TOGGLE_ON: `タップして画面高さ縮小を有効にする`,
    ADA_TOGGLE_OFF: `タップして画面高さ縮小を無効にする`,
    ADD: `追加`,
    ADD_DONATION: `寄付を追加`,
    ADD_FUNDS: `資金を追加`,
    ADD_TIP: `チップを追加`,
    ADD_TO_FAVORITES_WEB: ``,
    ADD_TO_ORDER: `注文に追加`,
    ADD_NEW: `新規追加`,
    ADDED: `追加済み`,
    ADDED_TO_FAVORITES_WEB: ``,
    ADDED_TO_ORDER: `注文に追加済み`,
    ADDON_TEXTFIELD_PLACEHOLDER: `選択肢を入力してください。`,
    ADDRESS_CITY: `市区町村`,
    ADDRESS_LINE_1: `番地`,
    ADDRESS_LINE_2: `部屋番号・フロア・スイート・棟・会社名（任意）`,
    ADDRESS_POSTAL_CODE: `郵便番号`,
    ALCOHOL_VERIFICATION: `アルコール確認`,
    ALREADY_HAVE_AN_ACCOUNT: ``,
    ALSO_CONSIDER: `こちらもおすすめ...`,
    APPLIED_STORED_VALUE_CARDS: `ギフトカード`,
    ASAP: `できるだけ早く`,
    AT_LEAST_X: `少なくとも {{$1: number}}`,
    BACK: `戻る`,
    BACK_TO_MENU: `メニューに戻る`,
    BACK_TO_MENU_FROM_LOYALTY: `メニューに戻る`,
    BACK_TO_CART: `カートに戻る`,
    BACK_TO_PAYMENT_OPTIONS: `支払い方法に戻る`,
    BACK_TO_PAYMENT_OPTIONS_FROM_LOYALTY: `支払い方法に戻る`,
    BAD_ACCESS_CODE: `アクセスコードが正しくありません`,
    BALANCE: `残高`,
    BAG_OPT_IN_PROMPT: `お持ち帰り袋をご注文に追加しますか？`,
    BAG_OPT_IN_TITLE: `袋を追加しますか？`,
    BAG_OPT_IN: `はい、袋が欲しいです`,
    BAG_OPT_OUT: `いいえ、結構です`,
    BLOCKED_WORD_WARNING: `ブロックされた単語を削除してください`,
    CALORIES: `カロリー`,
    CANCEL: `キャンセル`,
    CANCEL_CHECKOUT: `キャンセル`,
    CASH: `レジ係`,
    CARD_ENTRY_APM: `APM`,
    CARD_ENTRY_APPLE_PAY: `Apple Pay`,
    CARD_ENTRY_CARD_ON_FILE: `登録済みカード`,
    CARD_ENTRY_CHIP: `EMV`,
    CARD_ENTRY_CONTACTLESS: `非接触`,
    CARD_ENTRY_GOOGLE_PAY: `Google Pay`,
    CARD_ENTRY_MANUALLY_ENTERED: `手動入力`,
    CARD_ENTRY_PROVIDED_EXTERNALLY: `外部提供`,
    CARD_ENTRY_SCAN: `スキャン`,
    CARD_ENTRY_SWIPE: `スワイプ`,
    CARD_ENTRY_UNKNOWN: `不明`,
    CARD_EXPIRED: `カード期限切れ`,
    CARD_EXPIRING: `カードの有効期限が近づいています`,
    CART: `カート`,
    CART_LABEL: `{{$1: number}}点の商品（{{$2: price}}）のカートに移動`,
    CART_TITLE: ``,
    CHANGE_ITEM: `商品を変更`,
    CHANGE_PASSWORD: `パスワードを変更`,
    CHANGE_PASSWORD_SUCCESS: `パスワードが更新されました。`,
    CHARS_LEFT: `残り{{$1: number}}文字`,
    CHECK_AMOUNT: `金額を確認中...`,
    CHECKOUT: `お会計`,
    CHECKOUT_STEP_CART: `カート`,
    CHECKOUT_STEP_PAYMENT_OPTIONS: `支払い`,
    CHECKOUT_STEP_PAYING: `支払い中`,
    CHECKOUT_STEP_DONE: `完了`,
    CHECKOUT_WITH_FORCED_MENU: `Menu Previewを閲覧中に精算することはできません。精算は「Currently Shown（現在表示）」メニューを閲覧している時だけ利用できます。`,
    CHECK_YOUR_EMAIL: ``,
    CHOOSE_OPTION: `オプションを選択`,
    CHOOSE_TIME_SLOT: `時間帯を選択してください：`,
    CLEAR_ALL: `すべてクリア`,
    CLEARING_SESSION: `次のお客様のためにキオスクを準備中...`,
    CLOSE: `閉じる`,
    CLOSED_SCREEN_MESSAGE: `申し訳ありません。現在休業中またはモバイル注文を受け付けていません。`,
    CONFIRM: `確認`,
    CONFIRM_ADDRESS: `住所を確認`,
    CONFIRM_DISCARD: `この商品を破棄しますか？`,
    CONFIRM_DISCARD_CHANGES: `変更を破棄しますか？`,
    CONFIRM_YOUR_ITEM: `商品を確認してください`,
    CONFIRM_QUIT: `終了しますか？`,
    CONFIRM_REFUND_AMOUNT: `この取引から{{$1: dollar amount}}を返金しますか？`,
    CONFIRMING_YOUR_CARD: `カードを確認中...`,
    CONTINUE: `続ける`,
    CONTINUE_AS_GUEST: `ゲストとして続ける`,
    COULD_WE_INTEREST: `こちらはいかがでしょうか...`,
    COMP_CARD: `コンプカード`,
    COMP_CARD_SCAN: `コンプカードをスキャン`,
    COMP_CARD_SCAN_FAILED_TITLE: `コンプカードのスキャンに失敗`,
    COMP_CARD_SCAN_FAILED_MESSAGE: `コンプカードのスキャン中にエラーが発生しました。もう一度お試しください。`,
    COMP_CARD_APPLYING_TITLE: `コンプカードを適用中`,
    COMP_CARD_APPLYING_ERROR_TITLE: `コンプカードの適用エラー`,
    COMP_CARD_APPLYING_ERROR_MESSAGE: `コンプカードの適用中にエラーが発生しました。もう一度お試しください。`,
    COMP_CARD_ENTERING_NUMBER_ERROR_REQUIRED: `コンプカード番号を入力してください`,
    COMP_CARD_ENTERING_NUMBER_ERROR_INVALID: `有効なコンプカード番号を入力してください`,
    COMP_CARD_ENTERING_NUMBER_ERROR_LENGTH: `有効なコンプカード番号を入力してください`,
    COMP_CARD_ENTERING_PIN_ERROR_REQUIRED: `コンプカードのPINを入力してください`,
    COMP_CARD_ENTERING_PIN_ERROR_INVALID: `有効なコンプカードのPINを入力してください`,
    COMP_CARD_ENTERING_PIN_ERROR_LENGTH: `有効なコンプカードのPINを入力してください`,
    COMP_CARD_ENTERING_NUMBER_HINT: `コンプカード番号を入力してください。番号は{{$1: number}}桁です。`,
    COMP_CARD_ENTERING_PIN_HINT: `コンプカードのPINを入力してください。番号は{{$1: length}}桁です。`,
    COMP_CARD_ERROR_REMOVING: `コンプカードの削除中にエラーが発生しました。もう一度お試しください。`,
    'bottom-bar.storm-toggle.on': `タップしてStormナビゲーションを有効にする`,
    'bottom-bar.storm-toggle.off': `タップしてStormナビゲーションを無効にする`,
    'campus-card.label': `キャンパスカード`,
    'campus-card.payment-line-label': ``,
    'campus-card.payment-option-label': `タップしてキャンパスカードで支払う`,
    'campus-card.scan': `キャンパスカードをスキャン`,
    'campus-card.scan-failed.title': `キャンパスカードのスキャンに失敗`,
    'campus-card.scan-failed.message': `キャンパスカードのスキャン中にエラーが発生しました。もう一度お試しください。`,
    'campus-card.enter-number': `キャンパスカード番号を入力`,
    'campus-card.enter-pin': `キャンパスカードのPINを入力`,
    'campus-card.applying.title': `キャンパスカードを適用中`,
    'campus-card.applying.error.title': `キャンパスカードの適用エラー`,
    'campus-card.applying.error.message': `キャンパスカードの適用中にエラーが発生しました。もう一度お試しください。`,
    'campus-card.entering-number.error.required': `キャンパスカード番号を入力してください`,
    'campus-card.entering-number.error.invalid': `有効なキャンパスカード番号を入力してください`,
    'campus-card.entering-number.error.length': `有効なキャンパスカード番号を入力してください`,
    'campus-card.entering-number.hint': `キャンパスカード番号を入力してください。番号は{{$1: number}}桁です。`,
    'campus-card.entering-pin.error.required': `キャンパスカードのPINを入力してください`,
    'campus-card.entering-pin.error.invalid': `有効なキャンパスカードのPINを入力してください`,
    'campus-card.entering-pin.error.length': `有効なキャンパスカードのPINを入力してください`,
    'campus-card.entering-pin.hint': `キャンパスカードのPINを入力してください。番号は{{$1: length}}桁です。`,
    'campus-card.error-removing': `キャンパスカードの削除中にエラーが発生しました。もう一度お試しください。`,
    'campus-card.no-balance.title': `利用可能な残高なし`,
    'campus-card.no-balance.message': `このキャンパスカードに利用可能な残高がありません。`,
    'campus-card.add-another': `別のカードを追加`,
    'campus-card.remove': `キャンパスカードを削除`,
    'campus-card.select-account.title': `アカウントを選択`,
    'campus-card.select-account.loading': `アカウントを読み込み中...`,
    'campus-card.select-account.error.title': `アカウントを読み込めません`,
    'campus-card.select-account.error.message': `アカウントを読み込めませんでした。もう一度お試しください。`,
    'campus-card.select-account.column.account': `アカウント`,
    'campus-card.select-account.column.balance': `現在の残高`,
    'campus-card.select-account.error.toast-title': `エラー`,
    'campus-card.select-account.error.toast-message': `検証に失敗しました。もう一度お試しください。`,
    'campus-card.swipe': `キャンパスカードをスワイプして支払う`,
    COUPON: `クーポン`,
    COUPON_ALREADY_USED: `クーポンコードはすでに使用されています。`,
    COUPON_MIN_SPEND_NOT_MET: `入力したクーポンコードは最低購入金額を満たしていません。`,
    COUPON_NOT_FOUND: `クーポンコードが見つかりません。`,
    COUPON_NOT_ACCEPTED: `入力したクーポンコードは承認されませんでした。`,
    COUPON_APPLYING: `クーポンを適用中`,
    COUPON_APPLYING_ERROR_TITLE: `クーポン適用エラー`,
    COUPON_APPLYING_ERROR_MESSAGE: `クーポンの適用中にエラーが発生しました。もう一度お試しください。`,
    COUPON_ORDER_REQUIREMENTS_NOT_MET: `入力したクーポンコードは注文要件を満たしていません。`,
    COUPON_SCANNING_ERROR_TITLE: `クーポンスキャンエラー`,
    COUPON_SCANNING_ERROR_MESSAGE: `クーポンのスキャン中にエラーが発生しました。もう一度お試しください。`,
    COUPON_ENTERING_ERROR_LENGTH: `クーポンコードを入力してください。`,
    COUPON_ENTERING_ERROR_INVALID: `有効なクーポンコードを入力してください。`,
    COUPON_ERROR_REMOVING: `クーポンの削除中にエラーが発生しました。もう一度お試しください。問題が続く場合はスタッフにご連絡ください。`,
    CREATE_A_NEW_ACCOUNT: `新しいアカウントを作成`,
    CREATE_ACCOUNT: `アカウントを作成`,
    CREATE_ACCOUNT_TERMS_LINE: `アカウントを作成することで、以下に同意します：`,
    CREDIT_CARD: `クレジットカード`,
    CREDIT_CARD_NUMBER: `カード番号`,
    CURBSIDE: `カーブサイドピックアップ`,
    CURRENT_PASSWORD: `現在のパスワード`,
    CUSTOM_TIP: `カスタム`,
    CUSTOM_TIP_INVALID: `有効なチップ金額を入力してください。`,
    CUSTOM_TIP_HINT: `チップ金額を入力してください。最大：{{$1: number}}`,
    CUSTOM_DONATION: `カスタム寄付`,
    CUSTOMER_CARDS: `保存済みカードを使用`,
    CUSTOMER_ACCOUNT_BUTTON_LOG_IN: `ログイン`,
    CUSTOMER_ACCOUNT_BUTTON_LOG_IN_TOP_BAR: ``,
    CUSTOMER_ACCOUNT_BUTTON_LOGGED_IN: `マイアカウント`,
    CUSTOMIZE: `カスタマイズ`,
    DEBIT: `デビット`,
    DEBIT_CREDIT_CARD: `デビット/クレジットカード`,
    DEMO_PAY: `デモ：支払い`,
    DELIVERY: `デリバリー`,
    DELIVERY_ADDRESS: `配達先住所`,
    DELIVERY_INSTRUCTIONS: ``,
    DESELECTED_MOD_PREFIX: `{{$1: mod name}}を削除`,
    DINE_IN: `店内飲食`,
    DISCLAIMER_EMAIL: `メールアドレスの使用は利用規約に従います。`,
    DISCLAIMER_PHONE: `電話番号の使用は利用規約に従います。`,
    DISCLAIMER_PHONE_LINK: `利用規約：`,
    DISCLAIMER_PHONE_DESCRIPTION: `電話番号の使用について`,
    DISCLAIMER_NAME: `お名前はご注文の確認および指定エリアでのお受け取りに使用されます。`,
    DISCOUNTS: `割引`,
    DISCOUNTS_WILL_BE_APPLIED_AT_CHECKOUT: `割引はお会計時に適用されます`,
    DISCOUNT_WILL_BE_APPLIED_AT_CHECKOUT: `割引はお会計時に適用されます`,
    DONATION: `寄付`,
    DONATION_APPLYING: `寄付を処理中...`,
    DONATION_APPLY_ERROR_TITLE: `寄付の適用エラー`,
    DONATION_APPLY_ERROR_MESSAGE: `寄付の処理中にエラーが発生しました。もう一度お試しください。`,
    DONATION_FAILED: `寄付に失敗しました。もう一度お試しください。`,
    DONATION_ROUND_UP_TITLE: `合計金額を切り上げますか？`,
    DONATION_ROUND_UP_TO: `{{$1: amount}}に切り上げ`,
    DONATION_ROUND_UP_SUBTITLE: `合計金額を最も近い整数ドルに切り上げますか？`,
    DONATION_ROUND_UP_ACCEPT: `はい、切り上げます`,
    DONATION_ROUND_UP_REJECT: `いいえ、結構です`,
    DONATION_REMOVE: `寄付を削除`,
    DONE: `完了`,
    DONT_INCLUDE_UTENSILS: `カトラリー不要`,
    EBT: `SNAP EBT`,
    EBT_REFUND: `EBT返金`,
    EBT_CHOICE_DIALOG_TITLE: `どのEBT方法を使用しますか？`,
    EBT_CHOICE_CASH_BENEFIT: `現金給付`,
    EBT_CHOICE_FOOD_STAMPS: `フードスタンプ`,
    EBT_CARD_SUBTITLE: `クレジットカード端末でEBTカードをスワイプしてください`,
    EDIT: `編集`,
    EDIT_ORDER: `注文を編集`,
    EDIT_TIP: `チップを編集`,
    SAVE_ORDER: `注文を保存`,
    EMAIL_ADDRESS: `メールアドレス`,
    EMAIL_RECEIPT: `メールでレシートを受け取る`,
    EMAIL_REQUIRED_FOR_RECEIPT: `レシートにはメールアドレスが必要です。`,
    EMAIL_RECEIPT_SEND_FAILED: `レシートを送信できませんでした。もう一度お試しください。`,
    EMAIL_RECEIPT_SEND_SUCCESS: `レシートが正常に送信されました。`,
    ENTER_ACCESS_CODE: `アクセスコードを入力：`,
    ENTER_EMAIL_CUSTOMER_IDENTIFIER: `メールアドレスを入力`,
    ENTER_GIFT_CARD_BARCODE_FALLBACK: `スキャンできませんか？カード番号を入力してください。`,
    ENTER_PHONE_CONSENT: `SMSでマーケティング資料を受け取ることに同意します。`,
    ENTER_PHONE_CUSTOMER_IDENTIFIER: `電話番号を入力`,
    ENTER_PHONE_CUSTOMER_IDENTIFIER_WITH_NAME: `{{$1 guest name}}様、電話番号を入力してください`,
    ENTER_PHONE_LOYALTY: `携帯電話番号を入力`,
    ENTER_PHONE_RECEIPT: `レシートを受け取るには携帯電話番号を入力してください`,
    ENTER_PHONE_TEXT_WHEN_READY: `ご注文の準備ができたらSMSでお知らせします。電話番号を入力してください！`,
    ENTER_VEHICLE_DESCRIPTION: `お車の情報をご入力ください。お届けに伺います：`,
    ENTER_YOUR_COUPON_CODE: `クーポンコードを入力`,
    ENTER_YOUR_COMP_CARD_NUMBER: `コンプカード番号を入力`,
    ENTER_YOUR_COMP_CARD_PIN: `コンプカードのPINを入力`,
    ENTER_YOUR_GIFT_CARD_NUMBER: `ギフトカード番号を入力`,
    ENTER_YOUR_GIFT_CARD_PIN: `ギフトカードのPINを入力`,
    ENTER_YOUR_EMAIL: `メールアドレスを入力：`,
    ENTER_YOUR_EMAIL_VALIDATION_FAILED: `無効なメールアドレスです。もう一度お試しください。`,
    ENTER_YOUR_FIRST_NAME: `名前を入力：`,
    ENTER_YOUR_LAST_NAME: `苗字のイニシャルを入力：`,
    ENTER_YOUR_NAME: `お名前を入力：`,
    ENTER_YOUR_NAME_VALIDATION_FAILED: `無効な名前です。もう一度お試しください。`,
    ENTER_YOUR_NAME_VALIDATION_LENGTH_FAILED: `名前を入力してください。`,
    ENTER_YOUR_LAST_NAME_VALIDATION_LENGTH_FAILED: `1文字のみ入力できます。もう一度お試しください。`,
    ENTER_YOUR_NAME_VALIDATION_FORMAT_FAILED: `名前には文字のみ使用できます。もう一度お試しください。`,
    ENTER_YOUR_NAME_VALIDATION_PROFANITY_FAILED: `名前に不適切な言葉が含まれています。もう一度お試しください。`,
    ERROR: `おっと！`,
    ERROR_ADDING_ITEM: `カートへの商品追加中にエラーが発生しました。もう一度お試しください。問題が続く場合は、最寄りのスタッフにお声がけください。`,
    ERROR_EDITING_ITEM: `カート内の商品の編集中にエラーが発生しました。もう一度お試しください。問題が続く場合は、最寄りのスタッフにお声がけください。`,
    ERROR_AMOUNT_EXCEEDS_BALANCE: `金額がカードの残高を超えています。`,
    ERROR_CARD_CONFIRMATION: `申し訳ありません！カードを確認できませんでした。もう一度お試しください。`,
    ERROR_CARD_DECLINED: `指定されたカードへの請求に失敗しました。もう一度お試しください。`,
    ERROR_CARD_INACTIVE: `申し訳ありません。この学生証は有効ではありません。`,
    ERROR_CARD_NOT_FOUND: `申し訳ありません！このカードが見つかりませんでした。もう一度お試しください。`,
    ERROR_CARD_NUMBER_LENGTH: `カード番号の桁数が正しくありません。`,
    ERROR_CARD_RESTRICTED_TIME: `申し訳ありません。このカードは現在ご利用いただけません。`,
    ERROR_CARD_SCHEME_NOT_ACCEPTED: `申し訳ありません。こちらでは{{$1: cardScheme}}はご利用いただけません。別のカードをお試しください。`,
    ERROR_COUPON_CONFIRMATION: `申し訳ありません！クーポンコードを使用できませんでした。もう一度お試しください。`,
    ERROR_INVALID_EMAIL: `無効なメールアドレス`,
    ERROR_INVALID_LOGIN_CREDS: `無効なユーザー名またはパスワード`,
    ERROR_INVALID_NAME: `有効な名前を入力してください`,
    ERROR_INVALID_PHONE_NUMBER: `有効な電話番号を入力してください`,
    ERROR_INVALID_ROOM_NUMBER: `有効な部屋番号を入力してください`,
    ERROR_INVALID_TABLE_NUMBER: `有効なテーブル番号を入力してください`,
    ERROR_INVALID_VERIFICATION_CODE: `無効な確認コード`,
    ERROR_KIOSK_CARD_DECLINED: `問題が発生しました。カードへの請求はありませんでした。もう一度お試しください。`,
    ERROR_KIOSK_CARD_DECLINED_TAP: `カードを読み取れませんでした。もう一度お試しください。`,
    ERROR_KIOSK_PAYMENT_DEVICE_NOT_FOUND: `キオスクが決済端末を見つけられませんでした。カードへの請求はありませんでした。スタッフにご連絡ください。`,
    ERROR_KIOSK_PAYMENT_DEVICE_OFFLINE: `決済端末がオフラインのようです。カードへの請求はありませんでした。スタッフにご連絡ください。`,
    ERROR_ORDER_OPERATION: `申し訳ありません。ご注文を処理できませんでした。もう一度お試しください。`,
    ERROR_PIN_LENGTH: `PINの桁数が正しくありません。`,
    ERROR_RECEIVING_PAYMENT: `端末でお支払いを処理できませんでした。もう一度お試しください。`,
    ERROR_RECEIVING_PAYMENT_INSTRUCTIONS: `支払いが受け付けられませんでした。この注文は送信されていません。レシートに注文の概要が記載されます。スタッフにご連絡ください。`,
    ERROR_SENDING_ORDER: `キッチンへの注文送信中に問題が発生したようです。スタッフにご連絡ください。`,
    ERROR_SENDING_ORDER_INSTRUCTIONS: `支払いは成功しましたが、キッチンへの注文送信中に問題が発生しました。スタッフにご連絡ください。レシートに注文の概要が記載されます。`,
    ERROR_STARTING_ORDER: `申し訳ありません。注文を開始できませんでした。もう一度お試しください。問題が続く場合はスタッフにご連絡ください。`,
    ERROR_UPDATING_ORDER: `申し訳ありません。注文を更新できませんでした。もう一度お試しください。問題が続く場合はスタッフにご連絡ください。`,
    ERROR_VIEWING_ITEM_ALCOHOL_LIMIT: `この商品を表示できません。この注文のアルコール制限に達しました。この商品を追加するには、アルコール飲料を1点削除してください。`,
    ERROR_VIEWING_ITEM_SPECIAL_OFFER_LIMIT: `この商品を表示できません。この注文の特価商品制限に達しました。この商品を追加するには、特価商品を1点削除してください。`,
    EXIT: `終了`,
    EXIT_CONFIRMATION: `終了しますか？終了するとご注文がクリアされます。`,
    EXIT_TO_COVER: ``,
    FAVORITE: `お気に入り`,
    FAVORITES: `お気に入り`,
    FAVORITES_NONE_YET: `お気に入りはまだありません。`,
    FAVORITES_REMOVE_CONFIRMATION: `このお気に入りを削除しますか？`,
    FETCHING_RECOMMENDATIONS: `おすすめを取得中...`,
    FIND_ACCOUNT: `アカウントを検索`,
    FIRST_NAME: `名前`,
    FORGOT_PASSWORD: `パスワードをお忘れですか？`,
    FULFILLMENT_LABEL_ADDRESS: `住所`,
    FULFILLMENT_LABEL_GUEST_EMAIL: `メール`,
    FULFILLMENT_LABEL_GUEST_NAME: `宛先`,
    FULFILLMENT_LABEL_ORDER_NUMBER: `注文番号`,
    FULFILLMENT_LABEL_TABLE_NUMBER: `テーブル番号`,
    FULFILLMENT_LABEL_PHONE_NUMBER: `電話番号`,
    FULFILLMENT_LABEL_TRACKER_NUMBER: `トラッカー番号`,
    FULFILLMENT_LABEL_VEHICLE_DESCRIPTION: `車両の説明`,
    FULFILLMENT_INSTRUCTION_ADDRESS: `ご注文は以下の住所に配達されます。`,
    FULFILLMENT_INSTRUCTION_GUEST_EMAIL: `レシートをお送りします。`,
    FULFILLMENT_INSTRUCTION_GUEST_NAME: `ご注文の準備ができたらお名前をお呼びします。`,
    FULFILLMENT_INSTRUCTION_ORDER_NUMBER: `注文番号をお呼びします。`,
    FULFILLMENT_INSTRUCTION_PHONE_NUMBER: `ご注文の準備ができたらSMSでお知らせします。`,
    FULFILLMENT_INSTRUCTION_TABLE_NUMBER: `ご注文はテーブルまでお持ちします。`,
    FULFILLMENT_INSTRUCTION_TRACKER_NUMBER: `ご注文の準備ができたらトラッカーが鳴ります。`,
    FULFILLMENT_INSTRUCTION_VEHICLE_DESCRIPTION: `レストランの外にお到着次第、ご注文をお届けします。`,
    FULFILLMENT_TOGGLE: `受取方法を切り替える`,
    FULL_NAME: `フルネーム`,
    FUTURE_ORDER_MENU_FETCH_ERROR: `申し訳ありません！その時間帯のメニューが見つかりませんでした。もう一度お試しください。`,
    FUTURE_ORDER_NO_AVAILABLE_SLOTS: `申し訳ありません！利用可能な時間帯が見つかりませんでした。別の食事オプションをお試しください。`,
    FUTURE_ORDER_SET_FOR: `注文予約時間：`,
    FUTURE_ORDER_VALIDATION_WHEN_SLOT_EXPIRED_ERROR: `申し訳ありません！選択した時間帯はすでに利用できません。別の時間を選択してください。`,
    FUTURE_ORDER_ERROR_FETCHING_SLOTS: `利用可能な時間帯の取得中にエラーが発生しました。もう一度お試しください。問題が続く場合はスタッフにご連絡ください。`,
    FUTURE_ORDER_ERROR_SELECT_SLOT: `時間帯を選択してください。`,
    FUTURE_ORDER_TIME_SLOTS_TITLE: `時間帯`,
    FUTURE_ORDER_TIME_SLOTS_TODAY: `本日`,
    FUTURE_ORDER_TIME_SLOTS_TOMORROW: `明日`,
    FUTURE_ORDER_PICKUP_TIME_TODAY_AT: `本日{{$1: time}}受け取り`,
    FUTURE_ORDER_PICKUP_TIME_NEXT_BUSINESS_DAY_AT: `次の営業日{{$1: time}}受け取り`,
    FUTURE_ORDER_LEAD_TIME: `注文準備時間の目安：{{$1: time}}`,
    GENERIC_ERROR: `おっと！エラーが発生しました。もう一度お試しください。問題が続く場合はスタッフにご連絡ください。`,
    GET_REWARDS: `特典を取得`,
    GET_RECEIPT: `レシートを取得`,
    GET_RECEIPT_DIALOG_TITLE: `レシートのオプション`,
    GIFT_CARD: `ギフトカード`,
    GIFT_CARD_SECONDARY: `代替ギフトカード`,
    GIFT_CARD_TITLE: `今すぐ支払う`,
    GIFT_CARD_SUBTITLE: `ギフトカードをリーダーにスワイプしてお支払いください。`,
    GIFT_CARD_SCANNING_ERROR_TITLE: `ギフトカードスキャンエラー`,
    GIFT_CARD_SCANNING_ERROR_MESSAGE: `ギフトカードをスキャンできませんでした。もう一度お試しください。`,
    GIFT_CARD_APPLYING_TITLE: `ギフトカードを適用中`,
    GIFT_CARD_APPLYING_ERROR_TITLE: `ギフトカード適用エラー`,
    GIFT_CARD_APPLYING_ERROR_MESSAGE: `ギフトカードを適用できませんでした。もう一度お試しください。`,
    GIFT_CARD_NO_BALANCE_TITLE: `ギフトカードの残高不足`,
    GIFT_CARD_NO_BALANCE_MESSAGE: `ギフトカードに残高がありません。`,
    GIFT_CARD_ADD_ANOTHER: `別のカードを追加`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_REQUIRED: `ギフトカード番号を入力してください。`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_INVALID: `有効なギフトカード番号を入力してください。`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_LENGTH: `有効なギフトカード番号を入力してください。`,
    GIFT_CARD_ENTERING_PIN_ERROR_REQUIRED: `PINを入力してください。`,
    GIFT_CARD_ENTERING_PIN_ERROR_INVALID: `有効なPINを入力してください。`,
    GIFT_CARD_ENTERING_PIN_ERROR_LENGTH: `有効なPINを入力してください。`,
    GIFT_CARD_ENTERING_NUMBER_HINT: `ギフトカード番号を入力してください。番号は{{$1: length}}桁です。`,
    GIFT_CARD_ENTERING_PIN_HINT: `PINを入力してください。番号は{{$1: length}}桁です。`,
    GIFT_CARD_ERROR_REMOVING: `ギフトカードの削除中にエラーが発生しました。もう一度お試しください。問題が続く場合はスタッフにご連絡ください。`,
    'gift-card.select-account.title': `アカウントを選択`,
    'gift-card.select-account.loading': `アカウントを読み込み中...`,
    'gift-card.select-account.error.title': `アカウントを読み込めません`,
    'gift-card.select-account.error.message': `アカウントを読み込めませんでした。もう一度お試しください。`,
    'gift-card.select-account.column.account': `アカウント`,
    'gift-card.select-account.column.balance': `現在の残高`,
    'gift-card.select-account.error.toast-title': `エラー`,
    'gift-card.select-account.error.toast-message': `検証に失敗しました。もう一度お試しください。`,
    GLOSSARY_TERM_LEARN_MORE: `詳細を見る`,
    GOES_WELL_WITH: `一緒におすすめ`,
    GRAND_TOTAL: `合計`,
    GROUP_ORDERING_ADD_GUEST: `ゲストを追加`,
    GROUP_ORDERING_GUEST_NAME_INVALID_CHARACTERS: `ゲストの名前に無効な文字が含まれています。`,
    GROUP_ORDERING_GUEST_NAME_TAKEN: `このゲスト名はすでに使用されています。別の名前を入力してください。`,
    GROUP_ORDERING_GUEST_NUMBER_PREFIX: `ゲスト{{$1: number}}`,
    GROUP_ORDERING_ITEM_FOR: `グループ注文 - この商品は誰のですか？`,
    GROUP_ORDERING_LABEL: `グループ注文 - 商品の宛先：`,
    GROUP_ORDERING_TITLE: `グループ注文`,
    GROUP_ORDERING_SUBTITLE: `グループ注文オプションでは、各商品がグループのどのメンバーのものかを確認します。グループ注文を有効にするには「はい」をタップ、続けるには「いいえ」をタップしてください。`,
    GUEST_INFO: `ゲスト情報`,
    GUEST_RATING_LABEL_0: `タップして評価0を選択：非常に不満`,
    GUEST_RATING_LABEL_1: `タップして評価1を選択：やや不満`,
    GUEST_RATING_LABEL_2: `タップして評価2を選択：やや満足`,
    GUEST_RATING_LABEL_3: `タップして評価3を選択：非常に満足`,
    GUEST_RATING_0: `フィードバックをありがとうございました！`,
    GUEST_RATING_1: `フィードバックをありがとうございました！`,
    GUEST_RATING_2: `フィードバックをありがとうございました！`,
    GUEST_RATING_3: `フィードバックをありがとうございました！`,
    GUEST_RATING_SUBMITTED: `フィードバックをありがとうございました！`,
    HIDE: `非表示`,
    HOME: `ホーム`,
    HOW_DID_WE_DO: `いかがでしたか？評価をお願いします！`,
    HOW_WOULD_YOU_LIKE_TO_PAY: `お支払い方法を選択してください`,
    HOW_WOULD_YOU_LIKE_YOUR_ORDER: `ご注文方法を選択してください`,
    KITCHEN_CLOSED: `申し訳ありません。キッチンは現在閉まっています。`,
    ID_CHECK_LABEL: `ご注文にアルコールが含まれています。身分証明書の提示を求められる場合があります。`,
    ID_CHECK_CODE_MESSAGE: `アルコールの購入にはスタッフのアクセスコードが必要です。スタッフにお声がけください。`,
    IE_WARNING: `当社サイトへのアクセスにInternet Explorerをご利用になっているようです。快適にご利用いただくためには、Google Chrome、Safari、Firefox、Microsoft Edgeなど当社サイトがサポートするブラウザで開いて下さい。`,
    INCLUDE_UTENSILS: `カトラリーを含む`,
    ITEM_86D: `キッチンへの注文送信中に問題が発生しました。在庫切れの商品があります。スタッフにご連絡ください。`,
    ITEM_86D_VALIDATION: `品目の在庫がなく、お客様のご注文をキッチンに送信できません。スタッフの一員にお尋ね下さい。`,
    ITEM_RECIPIENT: `担当：`,
    ITEM_RECIPIENT_FOR: `{{$1: recipient}}様向け`,
    ITEM_RECIPIENT_PLACEHOLDER: ``,
    ITEM_RECOMMENDED_BADGE: `おすすめ`,
    ITEM_STEP_TITLE: `ステップ{{$1: step}}`,
    ITEM_STEP_EMPTY: `このステップでは選択がありませんでした`,
    ITEM_STEP_NO_RECOS: `おすすめはありません`,
    ITEMS_NO_LONGER_IN_MENU: `一部の商品はメニューからなくなったためカートから削除されました`,
    ITEM_SCAN_ERROR: `この商品が見つかりませんでした。メニューから追加していただくか、スタッフにお声がけください。`,
    ITEM_SCAN_SUCCESS: `商品がカートに追加されました！`,
    LAST_NAME: `苗字`,
    LEAD_TIME_LONG: `ご注文は現在選択されている時間帯よりも時間がかかる場合があります。`,
    LEAD_TIME_CART: `選択した商品のため、このご注文はリクエストした受け取り時間よりも長くかかる場合があります。`,
    LANGUAGE_SELECT_LABEL: `タップして言語を選択`,
    LOADING: `読み込み中...`,
    LOADING_MENU: `メニューを読み込み中...`,
    LOCATION_CARD_CLOSED: ``,
    LOCATION_CARD_LAST_VISITED: ``,
    LOCATION_CARD_OPEN: ``,
    LOCATION_CARD_SERVING_UNTIL: ``,
    LOCATION_CARD_OPENS_NEXT: ``,
    LOCATION_SEARCH_BUTTON: `店舗を検索`,
    LOCATION_SEARCH_FULFILLMENT_PROMPT: `{{$1: dine-in/take-away}}の店舗を検索`,
    LOCATION_SEARCH_FULFILLMENT_QUESTION: `ご注文方法は？`,
    LOCATION_SEARCH_HEADER: `{{$1: org name}}へようこそ`,
    LOCATION_SEARCH_INPUT_PLACEHOLDER: `住所、市区町村・都道府県、または郵便番号`,
    LOCATIONS_CHOOSE_A_LOCATION: ``,
    LOCATIONS_ENTER_DIFFERENT_CODE: ``,
    LOCATIONS_NONE_AVAILABLE: ``,
    LOG_IN_OR_JOIN: `ログイン`,
    LOGIN: `ログイン`,
    LOGIN_GIFT_CARD: `ギフトカードでログイン`,
    LOGIN_GIFT_CARD_SECONDARY: `代替ギフトカードでログイン`,
    LOGIN_WALL_WELCOME: `こんにちは！`,
    LOGIN_WALL_WELCOME_USER: `こんにちは、{{$1: user}}様！`,
    LOGIN_WITH_CARD_NUMBER: `カード番号でログイン`,
    LOGIN_WITH_PHONE: `電話番号でログイン`,
    LOOKING_UP_ACCOUNT: `アカウントを検索中...`,
    LOOKUP_CARD: `カードを検索中...`,
    LOOKUP_COUPON: `クーポンを検索中...`,
    LOYALTY: `ポイントプログラム`,
    LOYALTY_ACCOUNT_APPLY: `適用`,
    LOYALTY_CARD_NUMBER: `カード番号`,
    LOYALTY_EXIT_TO_MENU: `メニューへ`,
    LOYALTY_APP_AUTH_BARCODE_FALLBACK: `アプリのQRコードをスキャン`,
    LOYALTY_APP_AUTH_PHONE_FALLBACK: `アプリがない場合は電話番号を入力してください。`,
    LOYALTY_AUTH_METHOD_BARCODE: `アプリのQRコードをスキャン`,
    LOYALTY_AUTH_METHOD_HID: `HIDカードをタップ`,
    LOYALTY_AUTH_METHOD_PHONE: `電話番号を入力してください。`,
    LOYALTY_AUTH_METHOD_CARD_NUMBER: `カード番号を入力してください。`,
    LOYALTY_AUTH_METHOD_EMAIL: `メールアドレスを入力してください。`,
    LOYALTY_AUTH_METHOD_EMAIL_PASSWORD: `メールアドレスとパスワードを入力してください。`,
    LOYALTY_AUTH_METHOD_EMAIL_PHONE: `メールアドレスと電話番号を入力してください。`,
    LOYALTY_AUTH_METHOD_USERNAME_PASSWORD: `ユーザー名とパスワードを入力してください。`,
    LOYALTY_APP_AUTH_PHONE_FALLBACK_LABEL: `アカウントの電話番号を入力：`,
    LOYALTY_APP_AUTH_SUBTITLE: `バーコードを見つけるには、アプリでお支払い画面を開いてください。`,
    LOYALTY_APP_AUTH_TITLE: `下のスキャナーでアプリのお支払いバーコードをスキャンしてください。`,
    LOYALTY_APP_REDEMPTION_CODE_FALLBACK: `7桁の特典コードを手動入力`,
    LOYALTY_APP_REDEMPTION_CODE_FALLBACK_LABEL: `7桁の特典コードを入力：`,
    LOYALTY_APPLY_REWARD_FAILED: `特典の適用に失敗しました。もう一度お試しください。`,
    LOYALTY_APPLY_REWARD_FAILED_SPECIFIC: `次の特典の適用に失敗しました：{{$1: reward names}}。もう一度お試しください。`,
    LOYALTY_APPLYING_REWARD: `特典を適用中...`,
    LOYALTY_AUTH_GENERIC_ERROR: `申し訳ありません！このポイントアカウントが見つかりませんでした。もう一度お試しください。`,
    LOYALTY_AUTH_INSTRUCTIONS: `ポイントを獲得・利用するにはサインインしてください。`,
    LOYALTY_AVAILABLE_REWARDS_LABEL: `利用可能な特典`,
    LOYALTY_BALANCE_DESCRIPTION: ``,
    LOYALTY_BALANCE_LABEL: `現在の残高`,
    LOYALTY_CANNOT_MODIFY_REWARD: `申し訳ありません。注文のお支払い後は特典を変更できません。`,
    LOYALTY_CANNOT_REMOVE_REWARD: `申し訳ありません。この特典は注文に適用後は削除できません。`,
    LOYALTY_CARD_NUMBER_INSTRUCTIONS: `カード番号を入力してポイントを獲得・利用してください。`,
    LOYALTY_COUPON_BURNING_INCOMPATIBLE: `申し訳ありません。クーポンが適用されているため特典を使用できません。`,
    LOYALTY_GETTING_REWARDS: `特典を取得中...`,
    LOYALTY_FETCH_REWARDS_FAILED: `特典の取得に失敗しました。もう一度お試しください。`,
    LOYALTY_REWARD_APPLY: `適用`,
    LOYALTY_REWARD_APPLY_FAILED: `特典の適用に失敗しました。一部の特典はご注文に適用できない場合があります。`,
    LOYALTY_REWARD_APPLIED: `適用済み`,
    LOYALTY_REWARD_INVALID: `無効`,
    LOYALTY_REWARD_LABEL_MEAL: `食事`,
    LOYALTY_REWARD_LABEL_MEALS: `食事`,
    LOYALTY_REWARD_LABEL_UNSELECTED: `今すぐ交換`,
    LOYALTY_REWARD_LABEL_SELECTED: `選択済み`,
    LOYALTY_REWARD_LABEL_APPLIED: `交換済み`,
    LOYALTY_REWARD_LABEL_UNAPPLIED: `お会計時に交換`,
    LOYALTY_REWARD_LABEL_REMOVING: `削除中`,
    LOYALTY_REWARD_LABEL_ERROR: `適用エラー`,
    LOYALTY_REWARD_LABEL_UNAPPLICABLE: `適用不可`,
    LOYALTY_REWARD_GROUP_LABEL_UNKNOWN: `特典`,
    LOYALTY_REWARD_GROUP_LABEL_PERCENT: `割合ベースの特典`,
    LOYALTY_REWARD_GROUP_LABEL_FIXED: `固定特典`,
    LOYALTY_REWARD_GROUP_LABEL_WALLET: `ウォレット特典`,
    LOYALTY_REWARD_GROUP_LABEL_WALLET_AND_PAYMENT: `ウォレットと支払いの特典`,
    LOYALTY_REWARD_GROUP_LABEL_FREE_ITEM: `無料商品特典`,
    LOYALTY_REWARD_GROUP_LABEL_MEAL_EQUIVALENCY: `食事交換特典`,
    LOYALTY_REWARDS_FOR: `お客様名`,
    LOYALTY_NO_REWARDS_LABEL: `特典なし`,
    LOYALTY_NO_REWARDS_NO_EARNING: `これらの商品に適用できる特典はありません。`,
    LOYALTY_NO_REWARDS_TEXT: `これらの商品に適用できる特典はありませんが、この注文でポイントは獲得できます！`,
    LOYALTY_PAYMENT: `ポイント払い`,
    LOYALTY_PAYMENT_CARD_CHARGED: `登録カードに{{$1: charge_amount}}が請求されます。`,
    LOYALTY_PAYMENT_FAILED: `支払いの適用に失敗しました。`,
    LOYALTY_PAYMENT_FAILED_MESSAGE: `ポイント払いの処理中に問題が発生しました。もう一度お試しいただくか、別の支払い方法をお選びください。`,
    USE_LOYALTY_PAYMENT: `ポイントを使用`,
    LOYALTY_PAYMENT_SUBMIT: `支払いを完了`,
    LOYALTY_PAYMENT_REWARD: `ポイントから請求`,
    LOYALTY_PAYMENT_REWARD_DESCRIPTION: `プロバイダーに登録のカードにこの取引の料金が請求されます。`,
    LOYALTY_PAY_WITH_APP: `アプリで支払う`,
    LOYALTY_EARNED_POINT_ESTIMATE: `この注文の獲得予定ポイント：`,
    LOYALTY_EARNED_POINT_ESTIMATE_METRIC: `{{$1: number }}ポイント`,
    LOYALTY_INTRO_ACCOUNT_STATUS: `アカウントステータス`,
    LOYALTY_INTRO_COULD_NOT_FIND_ACCOUNT: `アカウントが見つかりませんでした。`,
    LOYALTY_INTRO_LOGIN_AND_EARN: `ポイントを獲得し特典を交換するには以下でログインしてください。`,
    LOYALTY_INTRO_PHONE_SIGN_UP: `電話番号で登録`,
    LOYALTY_INTRO_PHONE_SIGN_UP_DESCRIPTION: `登録後にレシートをスキャンすることで、今日の注文のポイントを獲得できます！`,
    LOYALTY_INTRO_QR_SIGN_IN: `以下のQRコードをスキャンしてログインしてください。`,
    LOYALTY_INTRO_QR_SIGN_UP: `以下のQRコードをスキャンして登録してください。`,
    LOYALTY_INTRO_WELCOME_BACK: `おかえりなさい、`,
    LOYALTY_FETCH_REWARDS_FAILED_NON_UNIQUE: `入力した電話番号は複数のポイントアカウントに関連付けられているか、存在しません。`,
    LOYALTY_REDEMPTION_CODE: `交換コードを適用`,
    LOYALTY_REMOVING_REWARD: `特典を削除中...`,
    LOYALTY_SCAN_FAILED_TITLE: `スキャン失敗`,
    LOYALTY_SCAN_FAILED_MESSAGE: `QRコードをスキャンできませんでした。もう一度お試しください。`,
    LOYALTY_SIGN_OUT_NOTICE: `注文が完了するか、メニューを終了すると自動的にサインアウトされます。`,
    LOYALTY_SIGN_OUT_NOTICE_PASSWORD: `注文が完了するか、メニューを終了すると自動的にサインアウトされます。パスワードは保存されません。`,
    LOYALTY_SIGN_UP_SMS_SENT: `登録メッセージを送信しました！`,
    LOYALTY_SIGN_UP_BACK_TO_LOGIN: `ログインに戻る`,
    LOYALTY_SIGN_UP_SUCCESS_TITLE: `登録完了！`,
    LOYALTY_SIGN_UP_WITH_QR: `QRコードで登録`,
    LOYALTY_SIGN_UP_WITH_PHONE_NUMBER: `電話番号で登録`,
    LOYALTY_WELCOME_TITLE: `ポイントを貯めて使おう`,
    LOYALTY_SIGNUP_TITLE: `登録リンクを電話に送信`,
    LOYALTY_YOU_CURRENTLY_HAVE: `現在お持ちのポイント`,
    LOYALTY_NAV_REWARDS: `マイ特典`,
    LOYALTY_NAV_ORDER_HISTORY: `注文履歴`,
    LOYALTY_SIGN_IN_ATTEMPTS_EXCEEDED: `ログイン試行回数の上限を超えました。`,
    GIFT_CARD_ACCESS_ATTEMPTS_EXCEEDED: `ギフトカードのアクセス試行回数の上限を超えました。`,
    MAKE_IT_A_COMBO: `セットにしますか？`,
    MAKE_IT_A_COMBO_MOD: `セットにしますか？`,
    MAKE_IT_A_COMBO_ACCEPT: `はい、お願いします！`,
    MAKE_IT_A_COMBO_REJECT: `いいえ、結構です！`,
    MAKE_IT_A_COMBO_NO: `いいえ、セットなしで`,
    MAKE_IT_A_COMBO_YES: `セットにしますか？`,
    MAKE_IT_A_COMBO_ACCEPTED_TITLE: `素晴らしい選択！`,
    MAKE_IT_A_COMBO_ACCEPTED_MESSAGE: `下でサイドメニューとドリンクをお選びください！`,
    MAKE_IT_A_COMBO_CHECKOUT_UPSELL_SUBTITLE: `サイドメニューとドリンクを追加してセットにしましょう！`,
    MENU_COVER_ALT_TEXT: `ここをタップして注文を始める`,
    MENU_COVER_LOYALTY_TEXT: `ポイントを貯めて特典を交換するにはポイントプログラムにログイン`,
    MENU_COVER_QUIZ_TEXT: `クイズに答えて最適な商品を見つけましょう！`,
    MENU_COVER_WAYFINDER_TEXT: `案内マップで場所を確認`,
    MAINTENANCE_COVER_TITLE: `このキオスクはメンテナンス中です`,
    MAINTENANCE_HID_DISCONNECTED_MESSAGE: `HIDがキオスクに接続されていることを確認してください。`,
    MAINTENANCE_HID_DISCONNECTED_TITLE: `HID切断`,
    MAINTENANCE_KDS_DISCONNECTED_MESSAGE: `KDSがキオスクに接続されていることを確認してください。`,
    MAINTENANCE_KDS_DISCONNECTED_TITLE: `KDS切断`,
    MAINTENANCE_KIOSK_UNAVAILABLE_MESSAGE: `別のキオスクをお試しいただくか、スタッフにお声がけください。`,
    MAINTENANCE_KIOSK_UNAVAILABLE_TITLE: `このキオスクは現在利用できません`,
    MAINTENANCE_MSR_DISCONNECTED_MESSAGE: `磁気ストライプリーダーがキオスクに接続されていることを確認してください。`,
    MAINTENANCE_MSR_DISCONNECTED_TITLE: `磁気ストライプリーダー切断`,
    MAINTENANCE_NETWORK_DISCONNECTED_MESSAGE: `キオスクがネットワークに接続されていることを確認してください。`,
    MAINTENANCE_NETWORK_DISCONNECTED_TITLE: `ネットワーク接続なし`,
    MAINTENANCE_NETWORK_UNSTABLE_MESSAGE: `このキオスクはインターネット速度が遅いため接続に問題があります。接続が安定しているか確認してください。推奨速度：アップロード・ダウンロードともに最低10 Mbps。`,
    MAINTENANCE_NETWORK_UNSTABLE_TITLE: `不安定なネットワークを検出`,
    MAINTENANCE_PAYMENT_CLIENT_DISCONNECTED_MESSAGE: `決済端末がオンになってキオスクに接続されていることを確認してください。`,
    MAINTENANCE_PAYMENT_CLIENT_DISCONNECTED_TITLE: `決済端末切断`,
    MAINTENANCE_PRINTER_COVER_OPEN_MESSAGE: `プリンターのカバーが閉まっていることを確認してください。`,
    MAINTENANCE_PRINTER_COVER_OPEN_TITLE: `プリンターカバーが開いています`,
    MAINTENANCE_PRINTER_DISCONNECTED_MESSAGE: `プリンターがキオスクに接続されていることを確認してください。`,
    MAINTENANCE_PRINTER_DISCONNECTED_TITLE: `プリンター切断`,
    MAINTENANCE_PRINTER_OUT_OF_PAPER_MESSAGE: `プリンターに用紙があることを確認してください。`,
    MAINTENANCE_PRINTER_OUT_OF_PAPER_TITLE: `プリンター用紙切れ`,
    MAINTENANCE_SCALE_DISCONNECTED_MESSAGE: `スケールがキオスクに接続されていることを確認してください。`,
    MAINTENANCE_SCALE_DISCONNECTED_TITLE: `スケール切断`,
    MAINTENANCE_SCANNER_DISCONNECTED_MESSAGE: `スキャナーがキオスクに接続されていることを確認してください。`,
    MAINTENANCE_SCANNER_DISCONNECTED_TITLE: `スキャナー切断`,
    MAX_ALCOHOLIC_ITEM_LIMIT_REACHED: `1注文あたりのアルコール飲料の上限は{{$1: number}}点です`,
    MAX_SPECIAL_ITEM_LIMIT_REACHED: `1注文あたりの特価商品の上限は{{$1: number}}点です`,
    MENU_COVER_DINING_OPTIONS: `ご注文方法は？`,
    MENU_COVER_LANGUAGE_OPTIONS: `言語を選択して開始`,
    MENU_COVER_PROMO_ALT_TEXT_ITEM: `ここをタップして注文を始め、このおすすめ商品をご覧ください：{{$1: item name}}！`,
    MENU_COVER_PROMO_ALT_TEXT_SECTION: `ここをタップして注文を始め、このおすすめセクションへ直接進みます：{{$1: section name}}！`,
    MENU_COVER_PROMO_ALT_TEXT_PAGE: `ここをタップして注文を始め、このおすすめページへ直接進みます：{{$1: page name}}！`,
    MENU_COVER_DINING_OPTION_ALT_TEXT: `「{{$1: fulfillment method}}」の注文を始めるにはここをタップ！`,
    MENU_COVER_BACK_TO_DINING_OPTIONS: `食事オプションに戻る`,
    MENU_COVER_BACK_TO_PHONE_NUMBER: `電話番号に戻る`,
    MARKETING_CONSENT: `ニュース、更新情報、割引、オファーを受け取りたい`,
    MENU_FILTERS_DIETARY_FILTERS: `食事制限`,
    MENU_FILTERS_DIETARY_FILTERS_DESCRIPTION: `より健康的な選択のために、オプションをここから１つ選択すると、該当するものだけがメニューとして表示されます`,
    MENU_FILTERS_NUTRITION_PREFERENCE: `栄養の好み`,
    MENU_FILTERS_OTHER_FILTERS: `その他`,
    MENU_FILTERS_OTHER_FILTERS_DESCRIPTION: ``,
    MENU_FILTERS_RESTRICTIVE_FILTERS: `制限あり`,
    MENU_FILTERS_RESTRICTIVE_FILTERS_DESCRIPTION: `食品に不耐性がある場合は、この中から１つを選んで、メニューに表示されないようにして下さい。`,
    MENU_FILTERS_COUNT: `{{$1: number}}件の栄養の好みが有効です。タップして編集。`,
    MOD_86D: `品目の在庫がなく、お客様のご注文をキッチンに送信できません。スタッフの一員にお尋ね下さい。お支払いは既にレストランが受取済みです。`,
    MOD_GROUP_AGGREGATE_QUANTITY: `合計 {{$1: number range, e.g. 2-3}} 品目`,
    MOD_GROUP_CHOICES_INCREMENT: `{{$1: number, e.g. you have to get 2/4/6 sauces}} の倍数`,
    MOD_GROUP_CHOICES_MAKE_ONE: `1つ独自の選択をする`,
    MOD_GROUP_CHOICES_MAKE_X: `{{$1: number range, e.g. 2-3}} の異なる選択をする`,
    MOD_GROUP_CHOICES_QUANTITY_PER: `1つの選択あたり {{$1: number range, e.g. 2-3}}`,
    MOD_GROUP_CHOOSE_AT_LEAST_X: `少なくとも{{$1: number}}つ選択`,
    MOD_GROUP_CHOOSE_BETWEEN_X_AND_Y: `{{$1: number}}〜{{$2: number}}つ選択`,
    MOD_GROUP_CHOOSE_ONE: `1つ選択`,
    MOD_GROUP_CHOOSE_UP_TO_ONE: `最大1つ選択`,
    MOD_GROUP_CHOOSE_UP_TO_X: `最大{{$1: number}}つ選択`,
    MOD_GROUP_CHOOSE_X: `{{$1: number}}つ選択`,
    MOD_GROUP_DEEMPHASIZE_SHOW: `表示 - {{$1: mod_group}}`,
    MOD_GROUP_DEEMPHASIZE_HIDE: `非表示 - {{$1: mod_group}}`,
    MOD_GROUP_WALLET_$_TO_SPEND: `金額が {{$1: dollar amount}} に達すると課金されます。`,
    MOD_GROUP_WALLET_ADDITIONAL_CHOICES_AT_$_PER: `1つあたり {{$1: dollar amount}} で、追加の選択。`,
    MOD_GROUP_WALLET_FIRST_X_FREE: `最初の {{$1: number}} は無料です。`,
    MOD_GROUP_WALLET_FIRST_SINGLE_FREE: `最初の1つは無料です。`,
    MOD_GROUP_WALLET_UP_TO_X: `1つの選択につき {{$2: dollar amount}} で最大 {{$1: number}} 個まで`,
    MOD_GROUP_SUBSTITUTION_MOD_CANCEL: `代替を閉じる`,
    MOD_GROUP_SUBSTITUTION_MOD_CHANGE: `代替を変更`,
    MOD_GROUP_SUBSTITUTION_MOD_SELECT: `代替する`,
    MOD_GROUP_SUBSTITUTION_UNSELECTED: `商品に追加`,
    MOD_RECOMMENDED_BADGE: `おすすめ`,
    MOD_UPSELL_PROMPT_TITLE: `オプションを追加しますか？`,
    MOD_UPSELL_PROMPT_ACCEPT: `追加`,
    MOD_UPSELL_PROMPT_DECLINE: `いいえ、結構です`,
    MODIFY: `変更`,
    MODIFY_INGREDIENTS: `食材を変更`,
    MORE: `もっと見る`,
    NAME_CALLED_ORDER_READY: `ご注文の準備ができたらお名前をお呼びします。`,
    NAME_ON_CARD: `カード名義人`,
    NEED_MORE_TIME: `もう少し時間が必要ですか？`,
    NEW_PASSWORD: `新しいパスワード`,
    NEXT: `次へ`,
    NO: `いいえ`,
    NO_ITEMS_MATCH_FILTERS: `フィルターに一致する商品がありません。`,
    NO_ORDERS_MATCH: `検索に一致する注文がありません。`,
    NO_THANKS: `いいえ、結構です`,
    NO_TIP: `チップなし`,
    NOT_A_MEMBER: `まだ会員ではありませんか？`,
    NUTRITION_INFO_CALORIES: `カロリー`,
    NUTRITION_INFO_PROTEIN: `タンパク質`,
    NUTRITION_INFO_FAT: `脂質`,
    NUTRITION_INFO_CARBS: `炭水化物`,
    NUTRITION_INFO_SUGAR: `糖質`,
    OK: `OK`,
    OR: `または`,
    OPT_OUT_OF_RECOMMENDATIONS: `おすすめを断る`,
    ORDER_GET_ERROR: `申し訳ありません。注文の作成中に問題が発生しました。もう一度お試しください。`,
    ORDER_HISTORY: `注文履歴`,
    ORDER_HISTORY_EMPTY: `注文履歴がありません。注文が完了すると、ここに表示されます。`,
    ORDER_HISTORY_ERROR: `申し訳ありません。注文履歴の読み込み中に問題が発生しました。もう一度お試しください。`,
    ORDER_SENT: `注文が送信されました`,
    ORDER_SUMMARY: `注文の概要`,
    ORDER_SUMMARY_WITH_NAME: `{{$1 guest name}}様の注文の概要`,
    ORDER_SUMMARY_LABEL: `注文の概要。{{$1 fulfillment}}の注文`,
    ORDER_SUMMARY_LABEL_WITH_NAME: `注文の概要。{{$2 guest name}}様の{{$1 fulfillment}}の注文`,
    ORDER_SUMMARY_LABEL_WITH_TABLE: `注文の概要。テーブル{{$2: table number}}の{{$1 fulfillment}}の注文`,
    ORDER_SUMMARY_LABEL_WITH_TRACKER: `注文の概要。トラッカー#{{$2: tracker number}}の{{$1 fulfillment}}の注文`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_TABLE: `注文の概要。テーブル{{$3: table number}}の{{$2 guest name}}様の{{$1 fulfillment}}の注文`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_TRACKER: `注文の概要。トラッカー#{{$3: tracker number}}の{{$2 guest name}}様の{{$1 fulfillment}}の注文`,
    ORDER_SUMMARY_LABEL_WITH_ORDER_NUMBER: `注文の概要。注文#{{$2: order number}}の{{$1 fulfillment}}の注文`,
    ORDER_SUMMARY_LABEL_WITH_TRACKER_AND_ORDER_NUMBER: `注文の概要。トラッカー#{{$2: tracker number}}、注文#{{$3: order number}}の{{$1 fulfillment}}の注文`,
    ORDER_SUMMARY_LABEL_WITH_TABLE_AND_ORDER_NUMBER: `注文の概要。テーブル{{$2: table number}}、注文#{{$3: order number}}の{{$1 fulfillment}}の注文`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_ORDER_NUMBER: `注文の概要。{{$2 guest name}}様、注文#{{$3: order number}}の{{$1 fulfillment}}の注文`,
    ORDER_SUMMARY_LABEL_WITH_NAME_TABLE_AND_ORDER_NUMBER: `注文の概要。テーブル{{$3: table number}}の{{$2 guest name}}様、注文#{{$4: order number}}の{{$1 fulfillment}}の注文`,
    ORDER_SUMMARY_LABEL_WITH_NAME_TRACKER_AND_ORDER_NUMBER: `注文の概要。トラッカー{{$3: tracker number}}の{{$2 guest name}}様、注文#{{$4: order number}}の{{$1 fulfillment}}の注文`,
    ORDER_THROTTLE_MAX_EXCEEDED: `申し訳ありません！レストランは対応能力を超えるご注文を受け付けています。別の時間帯でお試しください。`,
    ORDER_TIME_ASAP: `できるだけ早く注文`,
    ORDER_TIME_LATER: `本日のちほど`,
    ORDER_TIME_NEXT_BUSINESS_DAY: `次の営業日`,
    ORDER_TIME_FUTURE: `後で注文`,
    ORDER_TOTAL_MAX_EXCEEDED: `大量注文はスタッフにお声がけください。`,
    ORDER_UPDATE_FAILED: `注文の更新に失敗しました。`,
    ORDER_VALIDATION_IN_PROGRESS: `注文を確認中`,
    ORDER_VALIDATION_FAILED: `おっと！エラーが発生しました。`,
    ORDER_WAS_PLACED: `ご注文が完了しました。`,
    ORDERING_MODE_CHANGED: `注文モードが変更されました。セッションがリセットされました。`,
    ORDERED_ITEM_MAKE_IT_A_COMBO_LABEL: `{{$1: ordered item name}}をセットにするにはここをタップ。`,
    ORDERED_ITEM_COMBO_LABEL: `セット`,
    ORDERING_ITEM_ABSENCE_RESET: `この商品は最新ではありませんでした。商品は初期状態にリセットされました。もう一度お試しください。`,
    OUR_MENU: `メニュー`,
    OUTPOST_PICKUP: `アウトポストでのお受け取り`,
    OUTPOST_ROOM_NUMBER_INSTRUCTION: `アウトポストの部屋番号を入力`,
    OUTPOST_ROOM_NUMBER_TITLE: `部屋番号`,
    OUT_OF_STOCK: `在庫切れ`,
    PAGE_NAVIGATION_TITLE: `下のオプションのいずれかをタップして、メニューの特定のページに進みます。{{$1: total}}ページが利用可能です。`,
    PARTIAL_PAYMENT_LINE: `一部支払い`,
    PARTIAL_PAYMENT_WARNING_TITLE: `一部支払い`,
    PARTIAL_PAYMENT_WARNING_MESSAGE: `この注文に一部支払いがあります。戻る場合は、まずお支払いが返金されます。`,
    PASSWORD: `パスワード`,
    PASSWORD_REQUIREMENTS: ``,
    PASSWORD_UPDATED: ``,
    PASSWORD_UPDATED_LOG_IN_AGAIN: ``,
    PARTIAL_TENDER_TIMEOUT: `5分以内にお支払いが完了しない場合、注文をキャンセルし返金いたします。`,
    PAY_AT_CASHIER: `レジまでお進みください。`,
    PAY_NOW: `今すぐ支払う`,
    PAY_WITH: `支払い方法`,
    PAY_WITH_CREDIT: `クレジットカードで支払う`,
    PAY_WITH_DEBIT_CREDIT: `デビット/クレジットで支払う`,
    PAYMENT: `支払い`,
    PAYMENT_DETAILS: `支払い詳細`,
    PAYMENT_LINE_LABEL_DONATION: `{{$1: amount}}の寄付`,
    PAYMENT_LINE_LABEL_SUBTOTAL: `小計は{{$1: amount}}`,
    PAYMENT_LINE_LABEL_PARTIAL: `{{$1: amount}}の一部支払い`,
    PAYMENT_LINE_LABEL_GIFT_CARD: `{{$1: name}}のギフトカードで{{$2: amount}}を利用`,
    PAYMENT_LINE_LABEL_COUPON: `{{$1: name}}のクーポン割引{{$2: amount}}`,
    PAYMENT_LINE_LABEL_COMP_CARD: `{{$1: name}}のクーポン割引{{$2: amount}}`,
    PAYMENT_LINE_LABEL_EBT: `{{$1: amount}}のEBT支払い`,
    PAYMENT_LINE_LABEL_LOYALTY: `{{$1: name}}のポイント利用{{$2: amount}}`,
    PAYMENT_LINE_LABEL_REWARD: `{{$1: name}}の特典利用{{$2: amount}}`,
    PAYMENT_LINE_LABEL_DISCOUNT: `{{$1: name}}の割引{{$2: amount}}`,
    PAYMENT_LINE_LABEL_TAX: `税は{{$1: amount}}`,
    PAYMENT_LINE_LABEL_TIP: `チップは{{$1: amount}}`,
    PAYMENT_LINE_LABEL_SERVICE_CHARGE: `サービス料{{$1: amount}}`,
    PAYMENT_LINE_LABEL_NAMED_SERVICE_CHARGE: `{{$2: name}}のサービス料{{$1: amount}}`,
    PAYMENT_LINE_LABEL_TOTAL: `合計は{{$1: amount}}`,
    PAYMENT_LINE_LABEL_REMAINING: `残額は{{$1: amount}}`,
    PAYMENT_LINE_LABEL_PAID: `支払い済み金額は{{$1: amount}}`,
    PAYMENT_OPTION_LABEL_CASH: `タップして現金で支払う`,
    PAYMENT_OPTION_LABEL_CARD: `タップしてクレジットカードで支払う`,
    PAYMENT_OPTION_LABEL_COUPON: `タップしてクーポンを利用`,
    PAYMENT_OPTION_LABEL_COMP_CARD: `タップしてコンプカードを利用`,
    PAYMENT_OPTION_LABEL_DONATION: `タップして寄付を追加または編集`,
    PAYMENT_OPTION_LABEL_EBT: `タップしてEBTで支払う`,
    PAYMENT_OPTION_LABEL_EBT_REFUND: `タップしてEBTを返金`,
    PAYMENT_OPTION_LABEL_EBT_CASH_BENEFIT: `タップしてEBT現金給付で支払う`,
    PAYMENT_OPTION_LABEL_EBT_FOOD_STAMPS: `タップしてEBTフードスタンプで支払う`,
    PAYMENT_OPTION_LABEL_GIFT_CARD: `タップしてギフトカードで支払う`,
    PAYMENT_OPTION_LABEL_LOYALTY: `タップして特典を利用`,
    PAYMENT_OPTION_LABEL_LOYALTY_PAYMENT: `タップして特典を利用`,
    PAYMENT_OPTION_LABEL_FULLY_PAID: `タップして支払いを完了`,
    PAYMENT_PROMPT_NFC: `カードを挿入するか、スマートフォンをかざして支払ってください。`,
    PAYMENT_PROMPT_DIP: `カードを挿入して支払ってください。`,
    PAYMENT_SUCCESSFUL: `支払い完了`,
    PAYMENT_SUCCESSFUL_SUBTITLE: ``,
    PAYMENT_KIOSK_ERROR: `申し訳ありません。お支払いに失敗しました。もう一度お試しください。`,
    PAYMENT_KIOSK_TIMEOUT: `申し訳ありません。支払いセッションがタイムアウトしました。もう一度お試しください。`,
    PAYMENT_TOTAL: `支払い合計`,
    PAYMENT_WAS_TAKEN: `お支払いが処理されたことをご確認ください。`,
    PAYMENT_WAS_NOT_TAKEN: `お支払いは処理されていないことをご確認ください。これは支払いの確認ではありません。`,
    PHONE_NUMBER: `電話番号`,
    PHONE_NUMBER_OPTIONAL: ``,
    PICK_UP: `受け取り`,
    PICK_UP_AT: `受け取り場所`,
    PICK_UP_ENTER_NUMBER: `番号を取って以下に入力してください：`,
    PICK_UP_ENTER_NUMBER_WITH_NAME: `{{$1: guest name}}様、番号を取って以下に入力してください：`,
    PICK_UP_ENTER_NUMBER_TRACKER: `トラッカーを取ってその番号を入力してください：`,
    PICK_UP_ENTER_NUMBER_TRACKER_WITH_NAME: `{{$1: guest name}}様、トラッカーを取ってその番号を入力してください：`,
    PLACE_ORDER: `注文する`,
    PLEASE_ENTER_A_VALID_AMOUNT: `有効な返金金額を入力してください。`,
    PLEASE_USE_TEST_CARD: `この店舗はまだテストモードです。テストカードでお支払いください。`,
    PLEASE_WAIT: `しばらくお待ちください...`,
    PRICE: `価格は{{$1:price}}`,
    PRINTING_RECEIPT: `レシートを印刷中...`,
    PRINT_RECEIPT: `レシートを印刷`,
    PRINT_RECEIPT_ERROR: `申し訳ありません。レシートの印刷中にエラーが発生しました。後でもう一度お試しください。`,
    PRINTED_RECEIPT_COMMAND: `レシートをお忘れなく！`,
    PROCESSING_PAYMENT: `お支払いを処理中...`,
    PROMOTED_MODIFIER: `昇格しました！`,
    QUANTITY_SELECT: `{{$1:quantity}}を選択`,
    QUANTITY_SELECT_INCREASE: `数量を増やす`,
    QUANTITY_SELECT_DECREASE: `数量を減らす`,
    QUANTITY_SELECT_LABEL: ``,
    QUIT: `終了`,
    QUICK_CHECKOUT: `スピードチェックアウト`,
    QUICK_NAV_TAP_TO_VIEW: `タップして表示：`,
    QUIZ_RESULTS_TITLE: `結果`,
    QUIZ_RESULTS_EMPTY: `結果が見つかりませんでした。別の回答でもう一度お試しください。`,
    QUIZ_RESULTS_CAROUSEL_NEXT_LABEL: `タップして次の結果を表示。{{$2:total}}件中{{$1:index}}件目`,
    QUIZ_RESULTS_CAROUSEL_PREV_LABEL: `タップして前の結果を表示。{{$2:total}}件中{{$1:index}}件目`,
    QUIZ_STEP_ERROR: `続ける前にすべての質問にお答えください。`,
    QUIZ_STEP_ANSWER_LABEL: `タップして{{$1:badge name}}で回答：`,
    QR_CODE_RECEIPT_INSTRUCTIONS: `QRコードをスキャンしてスマートフォンでレシートのコピーを受け取ってください。`,
    RECEIPT_AUTHORIZATION: `承認`,
    RECEIPT_CARD_NUMBER: `カード番号`,
    RECEIPT_CHECK_ID: `チェックID`,
    RECEIPT_DISCOUNTS: `割引`,
    RECEIPT_DONATION: `寄付`,
    RECEIPT_FAILED: `キッチンへの注文送信中に問題が発生しました。スタッフにご連絡ください。`,
    RECEIPT_FAILED_ITEM_86D: `品目の在庫がなく、お客様のご注文をキッチンに送信できません。スタッフの一員にお尋ね下さい。`,
    RECEIPT_LOYALTY_POINTS_EARNED_TEXT: ``,
    RECEIPT_MENU_ITEMS_WITHOUT_BARCODE: `以下の品目は関係付けられたPLUがないため、QRコードには含まれませんでした：`,
    RECEIPT_NOT_RECEIPT: `これはレシートまたは購入証明書ではありません。`,
    RECEIPT_ORDER: `注文`,
    RECEIPT_ORDER_TOTAL: `注文合計`,
    RECEIPT_PAY_AT_CASHIER: `レジでお支払いください`,
    RECEIPT_PICK_UP_AT_LABEL: `受け取り場所`,
    RECEIPT_PICKUP_TIME_LABEL: `受け取り時間`,
    RECEIPT_DELIVERY_TIME_LABEL: `配達時間`,
    RECEIPT_PRINTED: `レシートが印刷されました`,
    RECEIPT_REFUNDED: `返金済み`,
    RECEIPT_REMAINING_BALANCE: `残高`,
    RECEIPT_SELF_SERVE: `セルフサービス品目：`,
    RECEIPT_SPECIAL_REQUEST: `特別なリクエスト`,
    RECEIPT_SUB_TOTAL: `小計`,
    RECEIPT_TAX_TOTAL: `税金合計`,
    RECEIPT_TIP_THANKS: `チップ（ありがとうございます！）`,
    RECEIPT_SERVICE_CHARGE: `サービス料`,
    RECEIPT_TRANS_NO: `キオスク取引番号`,
    RECEIPT_YOUR_CHECK_NUMBER: `お会計番号は`,
    RECOMMENDATIONS: `おすすめ`,
    RECOMMENDED_FOR_YOU: `あなたへのおすすめ`,
    REFUND: `返金`,
    REFUNDER_ALREADY_REFUNDED: `返金済み`,
    REFUNDER_DELAY_MESSAGE: `返金はアカウント明細に表示されるまで数日かかる場合があります。`,
    REFUNDER_INSTRUCTIONS: `レシートの認証番号、注文番号、メールアドレス、電話番号、カード番号の最後の4桁、取引参照番号、または注文IDを使用して、注文を検索して下さい。`,
    REFUNDER_SEARCH_PLACEHOLDER: `レシート認証番号、注文番号、またはカードの最後の4桁`,
    REFUNDER_TITLE: `注文を返金`,
    REFUNDER_SEARCHING_TITLE: `検索中`,
    REFUNDER_RESULTS_TITLE: `注文`,
    REFUNDER_RESULTS_EMPTY: `注文が見つかりませんでした。検索条件を確認して再度お試しください。`,
    REFUNDER_REFUNDING_TITLE: `返金中`,
    REFUNDER_REFUND_ERROR: `返金処理中にエラーが発生しました。もう一度お試しください。問題が続く場合はサポートにご連絡ください。`,
    REFUNDER_REFUND_SUCCESS: `返金成功！取引は間もなく処理されます。`,
    REFUNDER_REFUND_SUCCESS_BACK: `再検索`,
    REFUNDER_SEARCH_INPUT_ERROR: `有効な認証番号、注文番号、またはカード番号の下4桁を入力してください。`,
    REFUNDER_SEARCH_ERROR: `注文の検索中にエラーが発生しました。もう一度お試しください。問題が続く場合はサポートにご連絡ください。`,
    REFUNDING: `返金を処理中...`,
    REFUND_FAILED: `返金に失敗しました。後でもう一度お試しください。`,
    REMOVE: `削除`,
    REMOVE_CARD: `カードを取り忘れないでください。`,
    REMOVE_COMP_CARD: `コンプカードを削除`,
    REMOVE_COUPON: `クーポンを削除`,
    REMOVE_GIFT_CARD: `削除`,
    REMOVE_TIP: `チップを削除`,
    REMOVING_COUPON: `クーポンを削除中...`,
    REPEAT_PASSWORD: `パスワードを再入力`,
    RESET: `リセット`,
    REWARDS: `特典`,
    REWARDS_LOGGED_IN: `リワード`,
    REWARDS_APPLICABLE_TO_ORDER: `ご注文に今すぐ適用可能`,
    REWARDS_NOT_APPLICABLE_TO_ORDER: `ご注文にはまだ適用できません`,
    REWARDS_EDIT: `特典を編集`,
    REWARDS_BALANCE_POINT_LABEL: `{{$1: number}} ポイント`,
    REWARDS_BALANCE_MEAL_EQUIVALENCY_LABEL: `{{$1: number}}食`,
    REWARDS_COST_POINT_LABEL: `{{$1: number}} ポイント`,
    SAVE: `更新`,
    SAVE_CARD: `今後の購入のためにカードをアカウントに保存する。`,
    SCAN_COUPON_BELOW: `下のスキャナーでクーポンをスキャンできます。`,
    SCAN_YOUR_GIFT_CARD: `ギフトカードをスキャン`,
    SEARCH: `検索`,
    SEARCH_BEGIN: `下に検索キーワードを入力して検索を開始してください。`,
    SEARCH_EMPTY: `結果が見つかりませんでした。別の検索キーワードをお試しください。`,
    SEARCH_HINT: `名前または説明の組み合わせで商品を検索してください。`,
    SECRET_MENU_IMAGE_ALT: `タップしてシークレットメニューを表示`,
    SELECT_DATE: `日付を選択`,
    SELF_SERVE: `セルフサービス`,
    SEND: `送信`,
    SEND_LOYALTY_SMS: `SMSを送信`,
    SEND_ORDER_UI_TIMEOUT: `お客様のご注文のキッチンへの送信を今も実行中です。スタッフの一人にお尋ね下さい。`,
    SENT_LOYALTY_SIGNUP_SMS: `SMSを送信しました。電話をご確認の上、ご都合の良い時に登録して下さい。`,
    SENDING_ORDER_KITCHEN: `キッチンに注文を送信中...`,
    SENDING_ORDER_VALIDATION: `注文を確認中...`,
    SENDING_RECEIPT: `レシートを送信中...`,
    SENDING_SMS: `SMSを送信中`,
    SERVICE_CHARGE: `サービス料`,
    SHOW: `表示`,
    SHOW_NUTRITION: `栄養情報を表示`,
    SHOW_STAFF_FIRST: `終了の際に、スタッフの一員にこのメッセージをお見せ下さい。\n本当に終了しますか？`,
    SIGNUP_CTA: `アカウントを開設しましょう！`,
    SIGN_OUT: `サインアウト`,
    SIGN_UP: `登録`,
    SIGNUP_BENEFITS: `アカウントを作成してクレジットカードとお気に入り商品を保存し、スムーズなチェックアウトをお楽しみください。`,
    SIGNUP_LOYALTY: `ポイントプログラムに登録`,
    SKIP: `スキップ`,
    SPECIAL_REQUESTS: `特別リクエスト`,
    SPECIAL_REQUESTS_EXAMPLE: `例：ソースは別添え、アンチョビなしなど`,
    SPECIAL_REQUESTS_FINEPRINT: `変更や特別リクエストには追加料金が発生する場合があります。`,
    SPECIAL_REQUESTS_ADD: `特別リクエストを追加`,
    SPECIAL_REQUESTS_ERROR_TOO_LONG: `特別リクエストが長すぎます。`,
    SPECIAL_REQUESTS_ERROR_NO_INVALID_CHARACTERS: `文字、数字、句読点のみ使用してください。`,
    SPECIAL_REQUESTS_ERROR_NO_VALUE: `特別リクエストを入力してください。`,
    SR_REMOVE_ITEM_FROM_CART: `カートから品目を取り除いて下さい。`,
    STARTING_ORDER: `注文を開始中...`,
    UPDATING_ORDER: `注文を更新中...`,
    START_ORDER_BY_SCANNING: `キオスク下部で商品をスキャンして注文を始めてください。`,
    START_NEW_ORDER: `別の注文をする`,
    STORED_VALUE_REMAINING_BALANCE: `残高`,
    STORE_INFO: ``,
    STORE_INFORMATION: `店舗情報`,
    STUDENT_CARD: `学生証`,
    STUDENT_CARD_INSUFFICIENT_FUNDS: `申し訳ありません。この学生証の残高が不足しています。`,
    STUDENT_CARD_SUBTITLE_HID: `学生証をタップして支払う`,
    STUDENT_CARD_SUBTITLE_HID_MSR: `学生証をタップまたはスワイプして支払う`,
    STUDENT_CARD_SUBTITLE_MSR: `学生証をスワイプして支払う`,
    SUBMIT: `送信`,
    SUBTOTAL: `小計`,
    SUBTOTAL_REDUCED: `割引後の小計`,
    SUBTOTAL_INCREASED: `新規小計`,
    SUBTOTAL_WARNING_COMBO_SAVE_TITLE: `セットでお得になっています！`,
    SUBTOTAL_WARNING_COMBO_SAVE_LINE: `お得額`,
    SUCCESS: `成功`,
    SUMMARY_STEP_FOOTNOTE: ``,
    SUMMARY_STEP_NOTICE: ``,
    SWITCH_LOCATION: `店舗を変更`,
    SWITCH_TO_CATERING: `ケータリングに切り替え`,
    SWITCH_TO_WEB: `オンライン注文に切り替え`,
    SWIPE_YOUR_GIFT_CARD: `ギフトカードをスワイプして支払う`,
    SWIPE_YOUR_COMP_CARD: `コンプカードをスワイプして支払う`,
    SWIPE_OR_SCAN_YOUR_GIFT_CARD: `ギフトカードをスワイプまたはスキャンして支払う`,
    TAKING_LONGER_THAN_USUAL: `通常より時間がかかっています...`,
    TAP_HERE_FOR_LANGUAGE: `{{$1: language}}はここをタップ`,
    TAP_OUTSIDE_CLOSE: `外をタップして閉じる`,
    TAP_TO_REDEEM: `タップして交換`,
    TAXES: `税`,
    TERMS_OF_SERVICE: `利用規約`,
    TERMS_OF_SERVICE_LOAD_FAILED: `利用規約の読み込み中にエラーが発生しました`,
    TEXT_RECEIPT: `SMSでレシートを受け取る`,
    TEXT_RECEIPT_SEND_FAILED: `SMSでレシートを送信できませんでした。`,
    TEXT_RECEIPT_SEND_SUCCESS: `レシートを送信しました！`,
    TEXT_YOU_WHEN_READY: `ご注文の準備ができたらSMSでお知らせします。`,
    THANK_YOU: `ありがとうございます！`,
    THEN_PRESS_BUTTON_1: `その後、ボタンを押してください。`,
    THEN_PRESS_BUTTON_2: `xxx`,
    TIP: `チップ`,
    TIPPING: `チップ支払い中...`,
    TIP_AMOUNT_TOO_HIGH: `チップ金額が高すぎます。`,
    TIP_AMOUNT_TOO_LOW: `チップ金額が低すぎます。`,
    TIP_FAILED: `申し訳ありません！チップを追加できませんでした。もう一度お試しください。`,
    TIP_CANNOT_BE_MODIFIED: `申し訳ありません！注文のお支払い後はチップを変更できません。`,
    TIP_LABEL_PERCENT: `タップして{{$1: percent}}%（{{$2: amount}}）のチップを追加`,
    TIP_LABEL_FIXED: `タップして{{$1: amount}}のチップを追加`,
    TIP_LABEL_CUSTOM: `タップしてカスタムチップを追加`,
    TIP_LABEL_NONE: `タップしてチップを削除`,
    TO_GO: `お持ち帰り`,
    TOTAL: `合計`,
    TOTAL_CHANGED_SUBTOTAL_TEXT: `ご注文の一部の商品の価格が変更されました。`,
    TOTAL_CHANGED_SUBTOTAL_LEADING_TEXT: `小計が変更し現在は`,
    TOTAL_CHANGED_LEADING_TEXT: `総計が変更し現在は`,
    TOTAL_CHANGED_TRAILING_TEXT: `。ご注文を続けますか？`,
    TOTAL_PAID: `支払い済み合計`,
    TOTAL_REMAINING: `残額`,
    TOTAL_SUBSCRIPT: ``,
    TRY_AGAIN: `再試行`,
    UNABLE_TO_FETCH_LOCATION_EXPLANATION: `お客様の場所を特定できなかったようです。ご住所を入力して下さい。`,
    UNAVAILABLE_ITEM: `申し訳ありません。この商品は現在ご利用いただけません。`,
    UNIT_GRAM: `{{$1: amount}}g`,
    UNIT_NUTRITION_INFO_CALORIES: `{{$1: amount}}カロリー`,
    UNIT_NUTRITION_INFO_PROTEIN: `{{$1: amount}}タンパク質`,
    UNIT_NUTRITION_INFO_CARBS: `{{$1: amount}}炭水化物`,
    UNIT_NUTRITION_INFO_FAT: `{{$1: amount}}脂質`,
    UNIT_NUTRITION_INFO_SUGAR: `{{$1: amount}}糖質`,
    UP_TO_X: `最大で {{$1: number}} 個`,
    USE_COMP_CARD: `コンプカードを使用`,
    USE_COUPON: `クーポンを使用`,
    USE_EBT_CARD: `EBTカード`,
    USE_EBT_CASH_BENEFIT: `EBT現金給付`,
    USE_EBT_FOOD_STAMP: `EBTフードスタンプ`,
    USE_GIFT_CARD: `ギフトカードを使用`,
    USERNAME: `ユーザー名`,
    VALIDATION_MESSAGE_EMAIL_IS_INVALID: `メールアドレスは無効です`,
    VALIDATION_MESSAGE_FIELD_IS_REQUIRED: `{{$1: field name, e.g. 'email'}} が必要です`,
    VALIDATION_MESSAGE_FIELD_IS_REQUIRED_GENERIC: `この項目は必須です`,
    VALIDATION_MESSAGE_ONLY_LETTERS_AND_NUMBERS: `文字と数字のみ使用して下さい`,
    VALIDATION_MESSAGE_ONLY_LETTERS_NUMBERS_AND_SPECIAL_CHARS: `文字、数字、&、 #、. のみ使用して下さい`,
    VALIDATION_MESSAGE_PASSWORD_REQUIREMENTS: `パスワードは少なくとも数字1つ、大文字1つ、小文字1つを含み、最低14文字なければなりません。`,
    VALIDATION_MESSAGE_PHONE_NUMBER_IS_INVALID: `お電話番号は無効です`,
    VALIDATION_MESSAGE_POSTAL_CODE_IS_INVALID: `郵便コードは数字でなければなりません`,
    VENDOR_UNAVAILABLE_MESSAGE: `この店は現在閉店しています。営業時間をご確認の上、またお越しください。`,
    VEHICLE_COLOR: `車の色`,
    VEHICLE_MAKE: `車のメーカー`,
    VEHICLE_MODEL: `車のモデル`,
    VERIFY_ACCOUNT: `アカウントを確認`,
    VERIFY_ACCOUNT_CTA: `注文を開始するにはアカウントを確認してください。`,
    VIDEO_LOAD_FAILED: `動画の読み込みに失敗しました`,
    VIEW: `表示`,
    WE_APOLOGIZE: `ご不便をおかけして申し訳ありません。`,
    WEIGHING_INSTRUCTIONS: `商品をスケールの上に置いてください`,
    WELCOME_BACK: `おかえりなさい！あなたへのおすすめ商品：`,
    WELCOME_BACK_WITH_NAME: `おかえりなさい、{{$1: guest name}}様！あなたへのおすすめ商品：`,
    WELCOME_TO: `{{$1: org name}}へようこそ！`,
    WELCOME_TO_NO_NAME: ``,
    WHEN_WOULD_YOU_LIKE_YOUR_ORDER: `受け取り時間を選択`,
    WHICH_OUTPOST_FOR_YOUR_ORDER: `どこで受け取りますか？`,
    YES: `はい`,
    YOU_PREVIOUSLY_ORDERED: `以前ご注文された商品`,
    YOUR_CURRENT_LOCATION: `お客様の現在の位置`,
    YOUR_NAME: `お名前`,
    YOUR_ORDER: `ご注文`,
    YOUR_SUBTOTAL: `小計`,
    ZOOM_TOGGLE_ON: `タップしてピンチズームを有効にする`,
    ZOOM_TOGGLE_OFF: `タップしてピンチズームを無効にする`,
    ZOOM_INSTRUCTIONS: `ピンチズームが有効です。2本の指で拡大・縮小できます。`,
    STARBUCKS_COVER_1_BUTTON: `注文が決まっています`,
    STARBUCKS_COVER_2_BUTTON: `店内を案内`,
    STARBUCKS_COVER_2_TITLE: `体験、テイスティング、学び`,
    STARBUCKS_COVER_PROMO_A: `コーヒーファインダー`,
    STARBUCKS_COVER_PROMO_B: `Starbucks Rewards`,
    STARBUCKS_EXPERIENCES_TITLE: `体験`,
    STARBUCKS_EXPERIENCES_SUBTITLE: `シグネチャー体験を予約して、コーヒーの技術、演出、革新に浸ってください`,
    STARBUCKS_EXPERIENCES_RESERVE_NOW: `本日の予約`,
    STARBUCKS_EXPERIENCES_RESERVE_LATER: `あとで予約`,
    STARBUCKS_EXPERIENCES_BACK: `体験に戻る`,
    STARBUCKS_WAYFINDER_CARD_EXPERIENCE_BUTTON: `詳細を見る`,
    STARBUCKS_WAYFINDER_CARD_MENU_BUTTON: `メニューへ`,
    STARBUCKS_WAYFINDER_KIOSK_LABEL_FIND: `現在地はどこ？`,
    STARBUCKS_WAYFINDER_KIOSK_LABEL: `現在地`,
    STARBUCKS_WAYFINDER_BATHROOMS_LABEL: `お手洗い`,
    STARBUCKS_WAYFINDER_OPEN_SEATING_LABEL: `自由席`,
    STARBUCKS_WAYFINDER_HOTSPOTS_LABEL: `スポットを探す`,
    STARBUCKS_WAYFINDER_DIRECTIONS_TITLE: `指でドラッグして空間を探索してください。`,
    STARBUCKS_WAYFINDER_DIRECTIONS_SUBTITLE: `ハイライトされたスポットをタップして詳細をご覧ください。`,
    STARBUCKS_COFFEE_FINDER_QUESTION_1_TITLE: `冒険心`,
    STARBUCKS_COFFEE_FINDER_QUESTION_1_SUBTITLE: `どのくらい冒険的なコーヒーがお好みですか？`,
    STARBUCKS_COFFEE_FINDER_QUESTION_2_TITLE: `好みのフレーバー`,
    STARBUCKS_COFFEE_FINDER_QUESTION_2_SUBTITLE: `コーヒーを思い浮かべたとき、どのフレーバーが一番おいしそうですか？`,
    STARBUCKS_COFFEE_FINDER_QUESTION_3_TITLE: `強さ`,
    STARBUCKS_COFFEE_FINDER_QUESTION_3_SUBTITLE: `どのくらいの濃さのコーヒーがお好みですか？`,
    STARBUCKS_COFFEE_FINDER_QUESTION_4_TITLE: `好みのコーヒーの注文方法`,
    STARBUCKS_COFFEE_FINDER_QUESTION_4_SUBTITLE: `普段どのようにコーヒーを注文しますか？`,
    STARBUCKS_COFFEE_FINDER_QUESTION_EDIT: `タップして編集`,
    STARBUCKS_COFFEE_FINDER_QUESTION_CONFIRM: `選択を確認`,
    STARBUCKS_COFFEE_FINDER_QUESTION_RESTART: `最初からやり直す`,
    STARBUCKS_COFFEE_FINDER_ANSWER_TITLE: `お客様におすすめなのは`,
    STARBUCKS_COFFEE_FINDER_ANSWER_SUBTITLE: `豆だけを購入するか、この豆を使った下記のドリンクがおすすめです：`,
    STARBUCKS_COFFEE_FINDER_ANSWER_GO_TO_MENU: `メニュー全体を見る`,
    STARBUCKS_COFFEE_FINDER_ANSWER_RESTART: `最初からやり直す`,
    STARBUCKS_VIEW_WAYFINDER: `店内を案内`,
    STARBUCKS_VIEW_COFFEE_FINDER: `選択肢を絞る`,
    STARBUCKS_VIEW_EXPERIENCES: `体験を見る`,
    'cover.session.timeout': `問題が発生しました。もう一度お試しください。`,
    'cover.reduced-height.button': `注文を始める`,
    'cover.loyalty.title': `ようこそ`,
    'cover.five-guys.documents': ``,
    'cover.five-guys.allergen-nutrition': ``,
    'cover.five-guys.ingredients': ``,
    'cover.five-guys.storm-document-instructions': ``,
    'cover.loyalty.login': `ポイントプログラムでログイン`,
    'cover.loyalty.guest': `ゲストとして続ける`,
    'guest-identifier.button.quit': `終了`,
    'guest-identifier.button.skip': `スキップ`,
    'guest-identifier.button.back': `戻る`,
    'guest-identifier.button.next': `続ける`,
    'guest-identifier.button.submit.cover': `続ける`,
    'guest-identifier.button.submit.edit': `続ける`,
    'guest-identifier.button.submit.checkout': `続ける`,
    'guest-identifier.phone.tos.button-back': `戻る`,
    'guest-identifier.phone.tos.title': `利用規約`,
    'guest-identifier.phone.tos.link': `電話番号に関する利用規約`,
    'guest-identifier.phone.title': ``,
    'guest-identifier.table.instructions.table-number': ``,
    'guest-identifier.table.instructions.tracker-number': ``,
    'guest-identifier.name.loyalty-title': `ポイントアカウントでログイン`,
    'guest-identifier.name.loyalty-button': `ポイントプログラムでログイン`,
    'guest-identifier.name.loyalty-separator': `または`,
    'guest-identifier.name.loyalty-error-title': `おっと！名前が見つかりません`,
    'guest-identifier.name.loyalty-error-description': `このアカウントに関連する名前が見つかりませんでした。以下にお名前を入力してください`,
    'inactivity-timer.button.continue': `はい、もう少し時間が必要です`,
    'inactivity-timer.button.exit': `いいえ、完了しました`,
    'item-card.add.with-quantity': `追加 ({{$1: quantity}})`,
    'image.scan.default.alt': `バーコードまたはQRコードをスキャン`,
    'loyalty.view_coupons': `クーポンを見る`,
    'loyalty.add_coupons': `クーポンを追加`,
    'loyalty.label.manual_redemption': `交換コード`,
    'loyalty.label.manual_redemption_instructions': `交換コードを入力して特典を交換してください`,
    'loyalty.label.welcome.new-user': `こんにちは、{{$1: user}}様！ポイントアカウントが作成されました`,
    'loyalty.reward_label.payment_unapplied': `登録カードに支払いを適用`,
    'loyalty.reward_label.redeemable_unredeemed': `{{$1: points}}ポイントで交換`,
    'loyalty.reward_label.payment_at_checkout': `支払いはお会計時に適用できます`,
    'loyalty.reward_group_label.payment': `支払い特典`,
    'loyalty.rewards.payment-reward.name': `残高で支払う`,
    'loyalty.rewards.payment-reward.name-with-amount': `残高で支払う（{{$1: amount}}）`,
    'loyalty.rewards.payment-reward.description': `現在の残高`,
    'loyalty.rewards.card-on-file-payment.description': `登録済みのカードに支払いが請求されます。`,
    'loyalty.redemption_auth.back_to_rewards': `特典に戻る`,
    'loyalty.redemption_auth.subtitle': `交換バーコードをスキャンして特典を交換してください`,
    'loyalty.redemption_auth.submit': `特典を交換`,
    'loyalty.signup.header': ``,
    'loyalty.signup.email-already-exists': ``,
    'loyalty.signup.email-and-sms-consent': ``,
    'loyalty.signup.enter-your-email-address': ``,
    'loyalty.signup.enter-your-name': `お名前を入力`,
    'loyalty.signup.enter-your-phone-number': `(555) 555-5555`,
    'loyalty.signup.consent-required': `続けるには利用規約に同意してください。`,
    'loyalty.checkout-signup.header': `この注文で特典を獲得する最後のチャンスです！`,
    'loyalty.checkout-signup.skip': `スキップしてお会計へ`,
    'loyalty.checkout-signup.success.new-account.title': `新しいアカウントが作成されました`,
    'loyalty.checkout-signup.success.new-account.description': `ご参加ありがとうございます。この注文で特典を獲得できます！`,
    'loyalty.checkout-signup.success.existing-account.title': `アカウントはすでに存在します`,
    'loyalty.checkout-signup.success.existing-account.description': `この番号で以前登録済みです。現在ログインしています。`,
    'loyalty.checkout-signup.error.title': `アカウント作成エラー`,
    'loyalty.checkout-signup.error.description': `アカウント作成中に問題が発生しました`,
    'loyalty.checkout-signup.error.skip': `スキップしてお会計へ`,
    'loyalty.checkout-signup.error.try-again': `再試行`,
    'menu.item.reset': `商品をリセット`,
    'menu.mod-group.quick-select': `クイック選択`,
    'menu.mod-group.quick-select-active': `選択済み`,
    'menu.mod-group.quick-select-clear': ``,
    'menu.page.scanner.initial.title': `商品をスキャンして注文を始めましょう`,
    'menu.page.scanner.scanned.title': `カート内の商品`,
    'menu.scanned-item-added-dialog.button.go-to-scanner-page': `スキャンした商品を見る`,
    'order-history.button.add-to-order': `利用可能な商品を追加 ({{$1: number}})`,
    'order-history.title': `注文履歴`,
    'order-history.subtitle': `過去のすべての注文がここに表示されます。商品を操作して表示するか、現在の注文に追加できます。1回のタップで注文のすべての商品を追加できます。`,
    'order-history.next-page': `次へ`,
    'order-history.previous-page': `前へ`,
    'order-history.screen.close': `閉じる`,
    'order-history.screen.error.title': `問題が発生しました`,
    'order-history.screen.error.subtitle': `注文履歴の読み込みに失敗しました。後でもう一度お試しください。`,
    'order-history.screen.error.button.back': `戻る`,
    'order-history.screen.error.button.retry': `再試行`,
    'order-history.screen.no-orders': `以前の注文が見つかりませんでした。注文が完了したら、ここに戻って確認してください。`,
    'order-history.screen.order-has-quick-add-uneligible-items': `この注文の一部の商品はクイック再注文をご利用いただけません。商品を個別にタップして追加してください。`,
    'order-history.section.button.view-all': `自分の注文をもっと見る`,
    'order-history.topbar.button.back': `戻る`,
    'loyalty.unapplicable_rewards_warning_title': `適用不可の特典`,
    'loyalty.unapplicable_rewards_warning_description': `選択した特典を利用するには、該当する商品をカートに追加してください。特典と割引はお会計時に適用されます。`,
    'loyalty.unapplicable_rewards_warning_confirm': `適用`,
    'loyalty.discard_reward_changes.title': ``,
    'loyalty.discard_reward_changes.description': ``,
    'loyalty.discard_reward_changes.keep_editing': ``,
    'loyalty.discard_reward_changes.discard': ``,
    'loyalty.rewards.terms_button_label': ``,
    'loyalty.rewards.terms_dialog.apply': ``,
    'loyalty.rewards.terms_dialog.remove': ``,
    'loyalty.rewards.terms_dialog.back': ``,
    'loyalty.reward_ineligible.title': ``,
    'loyalty.reward_ineligible.title_generic': ``,
    'loyalty.reward_ineligible.title_plural': ``,
    'loyalty.reward_ineligible.description': ``,
    'loyalty.reward_ineligible.description_plural': ``,
    'loyalty.reward_ineligible.back_to_menu': ``,
    'loyalty.reward_ineligible.continue': ``,
    'loyalty.reward_ineligible.continue_plural': ``,
    'loyalty.auth_method.manual_redemption': `手動入力`,
    'loyalty.button.menu.authed': `特典`,
    'loyalty.button.menu.unauthed': `特典`,
    'loyalty.button.checkout.authed': `特典`,
    'loyalty.button.checkout.unauthed': `特典`,
    'loyalty.error.reward_failed_to_apply': `特典の適用に失敗しました。もう一度お試しください。`,
    'loyalty.login.pin.label': ``,
    'loyalty.login.pin.error-required': ``,
    'loyalty.login-options.button.skip.menu': `スキップしてメニューへ`,
    'loyalty.login-options.button.skip.checkout': `スキップして支払いへ`,
    'loyalty.login-options.button.skip.dining-option-collection': `スキップしてお会計へ`,
    'loyalty.login-options.title': `ログイン方法を選択するかゲストとして続ける`,
    'loyalty.login-options.subtitle': `後でいつでもログインできます`,
    'loyalty.login-options.signup.link': `アカウントをお持ちでない方は登録`,
    'loyalty.login-options.barcode.title': `バーコードをスキャン`,
    'loyalty.login-options.barcode.subtitle': `バーコードをスキャンしてログイン`,
    'loyalty.login-options.email-phone-number.title': `メールアドレスと電話番号`,
    'loyalty.login-options.email-phone-number.subtitle': `メールアドレスと電話番号を入力してログイン`,
    'loyalty.login-options.email-password.title': `メールアドレスとパスワード`,
    'loyalty.login-options.email-password.subtitle': `メールアドレスとパスワードを入力してログイン`,
    'loyalty.login-options.username-password.title': `ユーザー名とパスワード`,
    'loyalty.login-options.username-password.subtitle': `ユーザー名とパスワードを入力してログイン`,
    'loyalty.login-options.phone-number.placeholder': `(555) 555-5555`,
    'loyalty.login-options.phone-number.title': `電話番号`,
    'loyalty.login-options.phone-number.subtitle': `電話番号を入力してログイン`,
    'loyalty.login-options.card-number.title': `カード番号`,
    'loyalty.login-options.card-number.subtitle': `カード番号を入力してログイン`,
    'loyalty.login-options.email.title': `メールアドレス`,
    'loyalty.login-options.email.subtitle': `メールアドレスを入力してログイン`,
    'loyalty.login-options.or': `または`,
    'loyalty.login-options.popup.close': `閉じる`,
    'loyalty.error.or': `または`,
    'loyalty.login-error.saved-form': `送信された情報：`,
    'loyalty.login-error.try-again.button': `再試行`,
    'loyalty.otp.enter-code.title': `お送りしたコードを入力してください`,
    'loyalty.otp.sent-to.email': `{{$1: masked email}}にコードをメールで送信しました`,
    'loyalty.otp.sent-to.sms': `{{$1: masked phone number}}にコードをSMSで送信しました`,
    'loyalty.otp.verify': `確認`,
    'loyalty.otp.resend': `コードを再送信`,
    'loyalty.otp.code.error.invalid': `コードが正しくありません。もう一度お試しください。`,
    'loyalty.otp.send-error.message': `その情報に一致するアカウントを1件に特定できませんでした。ご確認の上、もう一度お試しください。`,
    'loyalty.login.fallback.phone-number.button': `代わりに電話番号を使用`,
    'loyalty.login.fallback.barcode.button': `代わりにバーコードまたはQRコードをスキャン`,
    'loyalty.login.fallback.card-number.button': `代わりにカード番号を使用`,
    'loyalty.login.fallback.email.button': `代わりにメールアドレスを使用`,
    'loyalty.login.fallback.email-phone-number.button': `代わりにメールアドレスと電話番号を使用`,
    'loyalty.login.fallback.email-password.button': `代わりにメールアドレスとパスワードを使用`,
    'loyalty.login.fallback.username-password.button': `代わりにユーザー名とパスワードを使用`,
    'loyalty.login.auth-method.phone-number.title': `電話番号`,
    'loyalty.login.auth-method.barcode.title': `バーコードまたはQRコードをスキャン`,
    'loyalty.login.auth-method.card-number.title': `カード番号`,
    'loyalty.login.auth-method.email.title': `メールアドレス`,
    'loyalty.login.auth-method.email-phone-number.title': `メールアドレスと電話番号`,
    'loyalty.login.auth-method.email-password.title': `メールアドレスとパスワード`,
    'loyalty.login.auth-method.username-password.title': `ユーザー名とパスワード`,
    'vitrine.error.order_validation_failed': `注文の確認に失敗しました。もう一度お試しください。`,
    'vitrine.error.handshake_failed': `キオスクに接続できませんでした。スタッフにご連絡ください。`,
    'vitrine.error.request_timeout': `リクエストを完了できませんでした。もう一度お試しください。`,
    'vitrine.error.request_aborted': `リクエストを完了できませんでした。もう一度お試しください。`,
    'vitrine.error.analytics_send_error': `分析データを送信できませんでした。もう一度お試しください。`,
    'vitrine.error.garcon_incompatible_build': `キオスクに接続できませんでした。スタッフにお声がけください。`,
    'vitrine.error.loyalty-login-no-matching-user-title': `アカウントが見つかりませんでした`,
    'vitrine.error.loyalty-login-no-matching-user-message': `入力された情報に一致するユーザーが見つかりませんでした。`,
    'vitrine.error.loyalty_not_enough_points': `選択した特典を交換するのに十分なポイントがありません。`,
    'vitrine.error.order_total_above_max': `注文合計が許可される上限を超えました。スタッフにご連絡ください。`,
    'vitrine.error.empty_menu': `選択したメニューは現在空です。別の食事オプションをお試しください。`,
    'maitred.error.integration_bad_config': `キオスクの設定に問題があるようです。スタッフにご連絡ください。`,
    'checkout.done.expo_receipt.error': `レシートを印刷できませんでした。もう一度お試しください。`,
    'checkout.done.expo_receipt.success': `レシートが送信されました！スタッフにお声がけください。`,
    'checkout.done.print-receipt.out-of-paper': `プリンターの用紙が切れています。レシートについてはスタッフにお声がけください。`,
    'refunder.viewing-results.button.cancel': `キャンセル`,
    'refunder.viewing-results.button.refund-all': `すべて返金`,
    'refunder.viewing-results.button.view-transaction': `取引を見る`,
    'refunder.viewing-results.button.done': `完了`,
    'refunder.viewing-results.button.back': `戻る`,
    'refunder.viewing-results.button.search': `注文を検索`,
    'refunder.viewing-results.refund-order.error-print-receipt': `注文は正常に返金されましたが、レシートを印刷できませんでした。もう一度印刷をお試しください。`,
    'refunder.viewing-results.refund-order.success': `注文が正常に返金されました。`,
    'refunder.viewing-results.refund-order.error': `注文の返金に失敗しました。もう一度お試しください。`,
    'refunder.viewing-results.order.refunded': `注文返金済み`,
    'refunder.viewing-results.order.total': `注文合計`,
    'refunder.search-form.button.back': `戻る`,
    'refunder.search-form.button.search': `検索`,
    'refunder.viewing-order.title': `注文 #{{$1: order number}} のすべての取引`,
    'refunder.viewing-order.subtitle': `返金する取引を選択してください。`,
    'refunder.viewing-order.button.cancel': `キャンセル`,
    'refunder.viewing-order.button.refund': `返金`,
    'refunder.viewing-order.button.refund-partial': `一部返金`,
    'refunder.viewing-order.button.retry': `再試行`,
    'refunder.viewing-order.button.done': `完了`,
    'refunder.viewing-order.button.back': `戻る`,
    'refunder.viewing-order.refund-transaction.error': `取引の返金に失敗しました。もう一度お試しください。`,
    'refunder.viewing-order.refund-transaction.success': `取引が正常に返金されました。`,
    'refunder.viewing-order.refund-transaction.error-print-receipt': `取引は正常に返金されましたが、レシートを印刷できませんでした。もう一度印刷をお試しください。`,
    'refunder.viewing-order.transaction.total': `合計`,
    'refunder.viewing-order.transaction.refunded': `返金済み`,
    'refunder.viewing-order.error.title': `エラー`,
    'refunder.viewing-order.error.message': `注文の読み込みに失敗しました。もう一度お試しください。`,
    'refunder.viewing-order.error.button.retry': `再試行`,
    'refunder.viewing-order.error.button.back': `戻る`,
    'refunder.partial-transaction-refund.error.amount-too-high': `金額が高すぎます。`,
    'refunder.partial-transaction-refund.error.amount-too-low': `金額が低すぎます。`,
    'refunder.partial-transaction-refund.error.amount-invalid': `金額が無効です。`,
    'refunder.partial-transaction-refund.error.amount-required': `金額は必須です。`,
    'refunder.partial-transaction-refund.error': `返金の処理中に問題が発生しました。もう一度お試しください。`,
    'refunder.partial-transaction-refund.button.submit': `一部返金を送信`,
    'refunder.partial-transaction-refund.button.back': `戻る`,
    'refunder.partial-transaction-refund.title': `取引の一部返金`,
    'refunder.partial-transaction-refund.hint': `返金したい金額を入力してください。最大金額は{{$1: amount}}です`,
    'refunder.partial-transaction-refund.label': `金額`,
    'refunder.partial-transaction-refund.placeholder': `0.00`,
    'checkout.cart.alcohol-verification.age-requirement': `21+`,
    'checkout.cart.group-ordering.actions.change-recipient': `宛先を編集`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.title': `商品を割り当てる相手`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.cancel': `キャンセル`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.add-new': `新規追加`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.reassign': `再割り当て`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.who-is-this-for': `この商品は誰のですか？`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.assign-to-guest': `このゲストに割り当て`,
    'checkout.cart.starbucks-stars': `{{$1: amount}} \u2605 の商品`,
    'checkout.cart.mod-group-heading': `{{$1: mod group name}}:`,
    'menu.nav.starbucks.menu': `メインメニュー`,
    'menu.nav.starbucks.experiences': `体験`,
    'menu.nav.starbucks.wayfinder': `案内マップ`,
    'menu.secret-menu.access-code.title': `アクセスコードを入力`,
    'menu.secret-menu.access-code.button.back': `戻る`,
    'menu.secret-menu.access-code.button.submit': `送信`,
    'menu.secret-menu.access-code.error': `アクセスコードが無効です`,
    'menu.secret-menu.access-code.success': `アクセスコードが承認されました`,
    'menu.toast.added-to-cart': `カートに追加しました`,
    'menu.toast.combo-savings': `セット割引！`,
    'menu.toast.discount-applied': `割引が適用されました！`,
    'menu.exit-verification.title': `マネージャーの確認が必要です`,
    'menu.exit-verification.description': `退出するにはスタッフのアクセスコードが必要です。チームメンバーにお声がけください。`,
    'menu-item.starbucks-stars': `{{$1: amount}} \u2605`,
    'menu-item.product-information.title': ``,
    'menu-item.product-information.open': ``,
    'menu-item.product-information.tab.product-info': ``,
    'menu-item.product-information.tab.nutrition': ``,
    'menu-item.product-information.tab.allergens': ``,
    'menu-item.product-information.nutrition.option': ``,
    'menu-item.product-information.empty': ``,
    'menu-item.scale.title': `商品をスケールの上に置いてください。`,
    'menu-item.scale.weight': `{{$1: weight}} {{$2: unit}}`,
    'menu-item.scale.weighs': `重量`,
    'menu-item.scale.price-per-unit': `{{$2: unit}}あたり{{$1: price}}`,
    'menu-item.scale.price': `価格`,
    'menu-item.scale.instructions': `スケールを使って商品の重さを量ってください。リセットするには、スケール上の指示されたボタンを押してください。`,
    'menu-item.scale.weight-per-unit': `{{$1: weight}} {{$2: unit}}`,
    'menu-item.scale.reading-weight': `計量中...`,
    'menu-item.scale.error-reading-weight': `重量の読み取り中にエラーが発生しました。もう一度お試しください。`,
    'menu-item.scale.error-no-weight': `注文に追加するには商品を計量してください。`,
    'menu-item.scale.no-scale': `スケールが検出されませんでした。スタッフにご連絡ください。`,
    'also-consider.title': `こちらもおすすめ...`,
    'also-consider.back-to-item': `商品に戻る`,
    'also-consider.add-to-order': `注文に追加`,
    'also-consider.skip-add-on': `追加をスキップ`,
    'menu-item.assorted.title': `詰め合わせを作る`,
    'menu-item.assorted.count': `{{$2: total}}点中{{$1: count}}点選択`,
    'menu-item.row-size-mod.option.none': `なし`,
    'menu-item.high-sugar-warning.description': `警告：このアイコンは、この商品の添加糖の含有量が、2,000カロリーの食事における添加糖の1日の推奨総摂取量の上限（50g）以上であることを示しています。添加糖を長期間にわたって大量に摂取すると、2型糖尿病、体重増加、虫歯のリスクが高まる可能性があります。`,
    'menu-item.high-sodium-warning.description': `警告：このアイコンは、この商品のナトリウム（塩分）含有量が、1日の推奨総摂取量の上限（2,300mg）を超えていることを示しています。ナトリウムの過剰摂取は、血圧を上昇させ、心臓病や脳卒中のリスクを高める可能性があります。`,
    'menu-item.group-ordering.items-for': `グループ注文 - 商品の宛先：`,
    'menu-item.group-ordering.prompt.title': `グループで注文しますか？`,
    'menu-item.group-ordering.prompt.description': `グループ注文オプションでは、各商品がグループのどのメンバーのものかを確認します。グループ注文を有効にするには「はい」をタップしてください。このオプションで続ける場合は「いいえ」をタップしてください。`,
    'menu-item.group-ordering.prompt.button.accept': `はい、グループ注文`,
    'menu-item.group-ordering.prompt.button.decline': `いいえ、結構です`,
    'menu-item.group-ordering.add-recipient': `新規追加`,
    'menu-item.group-ordering.add-recipient-name.dialog.title': `新しい宛先を追加`,
    'menu-item.group-ordering.add-recipient-name.dialog.placeholder': `宛先の名前を入力してください`,
    'menu-item.group-ordering.add-recipient-name.dialog.button.submit': `このゲストに割り当て`,
    'menu-item.group-ordering.add-recipient-name.dialog.button.cancel': `キャンセル`,
    'menu-item.group-ordering.recipient-picker.title': `誰のですか？`,
    'menu-item.group-ordering.recipient-picker.add-new': `新規追加`,
    'menu-item.nested-mod-groups.edit': `編集`,
    'menu-item.nested-mod-groups.popup.done': `完了`,
    'menu-item.nested-mod-groups.popup.cancel': `キャンセル`,
    'menu-item.nested-mod-groups.popup.back': `戻る`,
    'menu-item.nested-mod-groups.popup.next': `次へ`,
    'checkout.cart.remove-item-verification.title': `マネージャーの確認が必要です`,
    'checkout.cart.remove-item-verification.description': `カートからこの商品を削除するにはスタッフのアクセスコードが必要です。チームメンバーにお声がけください。`,
    'checkout.cart.confirm-remove-item.title': `商品を削除しますか？`,
    'checkout.cart.confirm-remove-item.description': `{{$1: item name}}をカートから削除してもよろしいですか？`,
    'checkout.cart.confirm-remove-item.cancel': `キャンセル`,
    'checkout.cart.confirm-remove-item.confirm': `削除`,
    'checkout.cart.pre-checkout-recommendations.title': `注文を完成させる`,
    'checkout.cart.pre-checkout-recommendations.continue-button': `続ける`,
    'checkout.cart.pre-checkout-recommendations.back-button': `戻る`,
    'checkout.cart.item-86d.title.items': `一部の商品はご利用いただけなくなりました`,
    'checkout.cart.item-86d.title.mods': `一部の変更はご利用いただけなくなりました`,
    'checkout.cart.item-86d.title.mixed': `一部の商品と変更はご利用いただけなくなりました`,
    'checkout.cart.item-86d.description.items': `以下の商品がカートから削除されました：`,
    'checkout.cart.item-86d.description.mods': `以下の変更が商品から削除されました：`,
    'checkout.cart.item-86d.description.mixed': `以下はご利用いただけなくなり、削除されました：`,
    'checkout.cart.item-86d.entity.menu-item': `{{$1: item name}}`,
    'checkout.cart.item-86d.entity.price-option': `{{$1: item name}} — {{$2: price option name}}`,
    'checkout.cart.item-86d.entity.mod': `{{$1: mod name}}（{{$2: item name}}内）`,
    'checkout.cart.item-86d.edit-item-button': `編集`,
    'checkout.payment-options.tip.invalid-tip-amount': `申し訳ありません。注文合計より大きいチップは適用できません。注文の小計から割引を差し引いた金額未満のチップ額を入力してください。`,
    'checkout.payment-options.name.title': `{{$1: name}}様、こんにちは`,
    'checkout.payment-options.gift-cards.prompt.title': `ギフトカードの方法を選択`,
    'checkout.payment-options.gift-cards.prompt.default-option': `ギフトカード`,
    'checkout.payment-options.pay-with-cash-machine.label': `タップして現金機で支払う`,
    'checkout.payment-options.pay-with-cash-machine.button': `現金`,
    'checkout.payment-options.donation.or': `または`,
    'checkout.payment-options.service-charge.info-message': ``,
    'checkout.payment-options.service-charge.info-label': `サービス料の情報`,
    'checkout.payment-options.credit-card.button.zero-balance': `注文する`,
    'checkout.payment-options.inline-loyalty.view-all': `すべての特典を見る`,
    'checkout.payment-options.inline-loyalty.apply': `特典を適用`,
    'checkout.payment-options.inline-loyalty.greeting': `{{$1: name}}様、こんにちは！`,
    'checkout.payment-options.inline-loyalty.star-balance': `スター残高：{{$1: stars}}\u2605`,
    'checkout.payment-options.inline-loyalty.celebration.title': `お誕生日おめでとうございます！`,
    'checkout.payment-options.inline-loyalty.celebration.title-with-name': `{{$1: name}}様、お誕生日おめでとうございます！`,
    'checkout.payment-options.inline-loyalty.celebration.subtitle': `プレゼントをお楽しみください！`,
    'checkout.payment-options.inline-loyalty.error.title': `特典を適用できません`,
    'checkout.payment-options.inline-loyalty.error.message': `特典の適用中にエラーが発生しました。もう一度お試しください。`,
    'loyalty.starbucks.header.redeemable-stars': `交換可能なスター`,
    'loyalty.starbucks.header.stars-expiring': `{{$1: stars}}\u2605が{{$2: date}}に失効`,
    'loyalty.starbucks.header.stars-no-expiry': `スターは失効しません`,
    'loyalty.starbucks.progress.next-status-by-date': `{{$2: date}}までに{{$1: stars}}\u2605を獲得して{{$3: level}}ステータスに到達`,
    'loyalty.starbucks.progress.next-status': `{{$1: stars}}\u2605を獲得して{{$2: level}}ステータスに到達`,
    'loyalty.starbucks.progress.maintain-status-by-date': `{{$2: date}}までに{{$1: stars}}\u2605を獲得して{{$3: level}}ステータスをもう1年延長`,
    'loyalty.starbucks.progress.maintain-status': `{{$1: stars}}\u2605を獲得して{{$2: level}}ステータスをもう1年延長`,
    'loyalty.starbucks.progress.extended': `もう1年延長されました`,
    'loyalty.starbucks.progress.annual-earned': `年間獲得数`,
    'loyalty.starbucks.progress.status-target': `{{$1: level}}ステータス`,
    'loyalty.starbucks.progress.to-extend': `延長するには`,
    'loyalty.starbucks.birthday.title': `{{$1: name}}様、お誕生日おめでとうございます！`,
    'loyalty.starbucks.birthday.title-no-name': `お誕生日おめでとうございます！`,
    'loyalty.starbucks.birthday.redeem': `お誕生日クーポンを利用しましょう！`,
    'loyalty.starbucks.birthday.description': `お好きなドリンクやスイーツをサービスでお楽しみください。お会計時に利用するか、注文時にバリスタにお伝えください。`,
    'loyalty.starbucks.birthday.valid-until': `{{$1: date}}まで有効`,
    'loyalty.starbucks.member-since': `{{$1: year}}年から会員`,
    'loyalty.starbucks.member-since.subtitle': `Starbucks Rewardsの会員でいてくださりありがとうございます。`,
    'checkout.paying.starbucks.title': `今すぐStarbucksアプリのQRコードをスキャンしてください`,
    'checkout.paying.starbucks.subtitle': `注文を完了するには、StarbucksアプリでScan to Pay機能をご用意ください。`,
    'checkout.paying.starbucks.cancel-button': `キャンセル`,
    'checkout.paying.error.loyalty-payment': `申し訳ありません。お支払いを処理できませんでした。もう一度お試しください。`,
    'checkout.paying.error.pos.print': `続けてレシートを印刷`,
    'checkout.paying.error.table-tracker.print': `続けてレシートを印刷`,
    'checkout.paying.error.table-tracker.title': `おっと！ページャーを取得できませんでした。`,
    'checkout.paying.error.table-tracker.instructions': `ご注文は完了しましたが、注文を追跡するテーブルトラッカーの発行中にエラーが発生しました。次のステップに進んでレシートをお受け取りください。`,
    'checkout.paying.error.title': `おっと！`,
    'checkout.paying.sending-table-tracker-request.title': `ページャーを発行中`,
    'checkout.paying.sending-table-tracker-request.subtitle': `テーブルトラッカーを発行しています。しばらくお待ちください。`,
    'checkout.paying.cash-machine.pinging.title': `現金機を確認中`,
    'checkout.paying.cash-machine.pinging.subtitle': `現金機が利用可能か確認しています。しばらくお待ちください。`,
    'checkout.paying.cash-machine.awaiting.title': `現金機は使用中です`,
    'checkout.paying.cash-machine.awaiting.subtitle': `現金機が利用可能になるまでお待ちください。`,
    'checkout.paying.cash-machine.awaiting.cancel-button': `キャンセル`,
    'checkout.paying.cash-machine.receiving.title': `現金機の準備完了`,
    'checkout.paying.cash-machine.receiving.subtitle': `現金機にお支払いを投入してください。`,
    'checkout.paying.cash-machine.receiving.cancel-button': `キャンセル`,
    'checkout.paying.cash-machine.receiving.cancel-refund-button': `キャンセルして支払いを返金`,
    'checkout.paying.cash-machine.receiving.partial-button': `残りを別の方法で支払う`,
    'checkout.paying.cash-machine.receiving.amount': `残り{{$1: amount}}`,
    'checkout.paying.cash-machine.receiving.take-change-prompt': `現金機からすべての紙幣と硬貨をお取りください。`,
    'checkout.paying.cash-machine.cancelling.title': `現金機の支払いをキャンセル中`,
    'checkout.paying.cash-machine.cancelling.subtitle': `現金機からすべての紙幣と硬貨をお取りください。`,
    'checkout.paying.cash-machine.cancelling.error.title': `現金機の支払いのキャンセルエラー`,
    'checkout.paying.cash-machine.cancelling.error.subtitle': `お支払いをキャンセルできませんでした。スタッフにお声がけください。`,
    'checkout.paying.cash-machine.cancelling.error.print': `続けてレシートを印刷`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.title': `釣り銭不足`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.subtitle': `現金機がお支払いのお釣りをご用意できなかったため、お支払いを返金いたしました。`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.try-again-button': `再試行`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.back-button': `戻る`,
    'checkout.paying.cash-machine.error.message': `現金機がお支払いを処理できませんでした。もう一度お試しください。`,
    'checkout.done.details.guest-name': `名前`,
    'checkout.done.details.table-number': `テーブル番号`,
    'checkout.done.details.tracker-number': `トラッカー番号`,
    'checkout.done.details.order-number': `注文番号`,
    'checkout.done.error.table-tracker.instructions': `ページャーの取得中にエラーが発生しました。ご注文は正常に処理されました。スタッフにお声がけください。`,
    'checkout.done.qr-code.error': `申し訳ありません。レシートのQRコードを生成できませんでした。`,
    'printer-receipt.stored-value-remaining-balance': `{{$1: label}}の残高`,
    'printer-receipt.order-ready-at': ``,
    'printer-receipt.punchh-barcode-header': ``,
    'printer-receipt.refund-receipt-header': ``,
    'order-reconciler.error.dining-option-unavailable': `選択した食事オプションはご利用いただけなくなりました。ご注文は「{{$1: dining option name}}」を使用するよう更新されました。`,
    'order-reconciler.error.items-unavailable': `ご注文の一部の商品はご利用いただけなくなりました。ご注文は利用できない商品を削除するよう更新されました。以下の商品が削除されました：{{$1: item names}}`,
    'page-nav.order-history-item.title': `注文履歴`,
    'page-nav.order-history-item.cta': `注文履歴を見る`,
    'print.error.phone-number-label': `電話番号`,
    'print.error.guest-name-label': `名前`,
    'print.error.table-number-label': `テーブル番号`,
    'print.error.tracker-number-label': `トラッカー番号`,
    'print.error.order-number-label': `注文番号`,
    'debug.untranslated-locale': ``,
};
//# sourceMappingURL=strings.ja-jp.js.map